<template>
  <div class="rma-order-page">
    <Card dis-hover>
      <div class="page-body">
        <Form ref="qForm" :label-width="90" label-position="right" inline>
          <FormItem label="记录编号">
            <Input v-model="listQuery.recordNumber" clearable style="width: 160px" placeholder="记录编号" />
          </FormItem>
          <FormItem label="客户名称">
            <Input v-model="listQuery.customerName" clearable style="width: 160px" placeholder="客户名称" />
          </FormItem>
          <FormItem label="事业部">
            <Select v-model="listQuery.causeDepartment" :disabled="isFixedDepartment" transfer clearable style="width: 160px" placeholder="全部">
              <Option v-for="o in (initOptions.causeDepartments || [])" :key="o.value" :value="o.value">{{ o.text }}</Option>
            </Select>
          </FormItem>
          <FormItem label="状态">
            <Select v-model="listQuery.status" transfer clearable style="width: 160px" placeholder="全部">
              <Option v-for="o in (initOptions.orderStatuses || [])" :key="o.value" :value="o.value">{{ o.text }}</Option>
            </Select>
          </FormItem>
          <FormItem :label-width="0">
            <Button type="primary" icon="ios-search" class="toolbar-btn" @click="loadList(1)">查询</Button>
            <Button type="primary" icon="md-add" class="toolbar-btn" @click="openCreateModal">新增</Button>
          </FormItem>
        </Form>
        <Table :loading="listLoading" border :columns="tableColumns" :data="list" no-data-text="暂无数据" />
        <Page show-total show-sizer class="margin-top-10 fengpage" :total="totalCount" :page-size="pageSize" :current="currentPage" @on-change="onPage" @on-page-size-change="onPageSize" />
      </div>

      <RMAOrderCreateForm v-model="createModalShow" :edit-id.sync="createEditId" :workflow-focus="createWorkflowFocus" :initOptions="initOptions" @success="onCreateFormSuccess" />

      <RMAOrderPrint v-model="printModalShow" v-if="isShowPrint" :info-data="printOrderId" @succesConfirm="closeRmaPrintModal" />

      <Modal v-model="detailModalVisible" :title="detailModalTitle" width="1220" class-name="rma-detail-ivu-modal" :mask-closable="false" @on-visible-change="onDetailModalVisibleChange">
        <div class="rma-detail rma-detail-modal-body">
          <Spin v-if="detailLoading" fix />
          <div v-if="!detailOrder && !detailLoading" class="rma-empty">未加载到数据</div>
          <div v-else-if="detailOrder">
            <div class="rma-detail-hero">
              <div class="rma-detail-hero-main">
                <span class="rma-detail-hero-record">{{ detailOrder.recordNumber || '—' }}</span>
                <Tag :color="detailStatusTagColor">{{ detailOrder.statusText || statusText(detailOrder) }}</Tag>
              </div>
              <div v-if="detailOrder.formNumber" class="rma-detail-hero-meta">表单编号 {{ detailOrder.formNumber }}</div>
              <div class="rma-detail-hero-line">
                <span>{{ detailOrder.customerName || '—' }}</span>
                <span class="rma-detail-hero-dot">·</span>
                <span>{{ detailOrder.materialName || '—' }}</span>
              </div>
            </div>

            <div class="rma-section rma-detail-main-tabs">
              <Tabs v-model="detailInfoTab" :animated="false">
                <TabPane label="详情" name="base">
                  <div class="rma-detail-tab-detail">
                    <template v-if="detailOrder">
                      <table class="rma-native-table rma-detail-kv-table">
                        <colgroup>
                          <col class="rma-kv-col-label" />
                          <col class="rma-kv-col-value" />
                          <col class="rma-kv-col-label" />
                          <col class="rma-kv-col-value" />
                          <col class="rma-kv-col-label" />
                          <col class="rma-kv-col-value" />
                        </colgroup>
                        <tbody>
                          <tr v-for="(rowCells, ri) in detailInfoKvRowCells" :key="'ikv-' + ri">
                            <td v-for="(td, ti) in rowCells" :key="'ikv-' + ri + '-' + ti" :class="td.kind === 'label' ? 'rma-kv-label' : 'rma-kv-value'">
                              {{ td.text }}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </template>
                    <div v-else class="rma-table-empty">暂无数据</div>

                    <div v-if="detailFeedBacks.length" class="rma-section rma-fb-section">
                      <div class="rma-fb-section-head">
                        <span class="rma-fb-section-title">不合格项</span>
                        <span class="rma-fb-section-count">共 {{ detailFeedBacks.length }} 条</span>
                        <span v-if="detailShowEngineeringWorkflow" class="rma-fb-section-hint">请在各项内查看问题描述并填写工艺方案，最后在下方选择工艺处置结论</span>
                        <span v-else-if="detailEngineeringReadonlyVisible" class="rma-fb-section-hint">各项内可查看对应不合格项下已提交的工艺方案</span>
                      </div>
                      <Form ref="wf2Form" :label-width="120" :model="wf2" :rules="wf2FormRules" label-position="right" class="rma-wf-form rma-fb-collapse-form">
                        <Collapse v-model="detailFbActiveKeys" class="rma-fb-collapse">
                          <Panel v-for="(fb, fi) in detailFeedBacks" :key="fbPanelKey(fb, fi)" :name="fbPanelKey(fb, fi)">
                            <span class="rma-fb-panel-hd">
                              不合格项{{ fi + 1 }}
                              <Tag v-if="fb.statusText" size="small" type="border" class="rma-fb-panel-tag" @click.native.stop>{{ fb.statusText }}</Tag>
                            </span>
                            <div slot="content" class="rma-fbline-body">
                              <div class="rma-fb-desc-group">
                                <div class="rma-fbline-label rma-fbline-label--desc">问题描述</div>
                                <div class="rma-fbline-desc rma-fbline-desc--main">{{ fb.problemDescription || '—' }}
                                  <template v-if="fb.pictureFiles && fb.pictureFiles.length">
                                    <div class="rma-fbline-pics">
                                      <div class="rma-uploads">
                                        <div v-for="(pic, pidx) in fb.pictureFiles" :key="(pic.guid || pic.fileGuids || pic.id) + '-' + pidx" class="rma-thumb rma-thumb--rounded rma-thumb--fb">
                                          <img :src="rmaAttachmentImgSrc(pic)" :alt="pic.fileName || '图片'" @click="openRmaAttachmentPreview(pic)" />
                                        </div>
                                      </div>
                                    </div>
                                  </template>
                                </div>
                              </div>

                              <div v-if="detailShowEngineeringWorkflow && wf2.feedBackPlans[fi]" class="rma-wf2-under-fb">
                                <div class="rma-wf2-under-fb-head">工艺方案</div>
                                <FormItem label="临时处理方案" required :prop="'feedBackPlans.' + fi + '.temporaryTreatmentPlan'">
                                  <Input v-model="wf2.feedBackPlans[fi].temporaryTreatmentPlan" type="textarea" :rows="3" placeholder="必填" />
                                </FormItem>
                                <FormItem label="附件">
                                  <div class="rma-uploads rma-wf2-plan-uploads">
                                    <div v-for="(pic, pidx) in wf2.feedBackPlans[fi].pics" :key="(pic.fileGuids || pic.guid) + '-' + pidx" class="rma-thumb rma-thumb--rounded rma-wf2-plan-thumb">
                                      <img :src="baseUrl + pic.url" @click="openPreview(pic.url)" />
                                      <div class="rma-thumb-del-hit" title="删除" @click.stop="removeWf2PlanPic(fi, pidx)">
                                        <span class="rma-thumb-del-icon" aria-hidden="true">
                                          <Icon type="md-close" :size="16" />
                                        </span>
                                      </div>
                                    </div>
                                    <Upload :key="wf2.feedBackPlans[fi]._uploadGuid + '-w2-' + fi" :show-upload-list="false" :on-success="(res, file) => onWf2PlanSuccess(fi, res, file)" :on-format-error="onFormatError"
                                      :action="wf2PlanUploadAction(fi)" :before-upload="() => beforeWf2PlanUpload(fi)" accept="image/*" type="drag" class="rma-upload-add">
                                      <div class="rma-upload-add-inner">+</div>
                                    </Upload>
                                  </div>
                                </FormItem>
                              </div>

                              <div v-if="detailEngineeringReadonlyVisible && detailEngineeringReadonlyPerFb[fi]" class="rma-wf2-under-fb rma-wf2-under-fb--readonly">
                                <div class="rma-wf2-under-fb-head">工艺方案（已提交）</div>
                                <table class="rma-native-table rma-detail-kv-table rma-wf2-readonly-kv">
                                  <colgroup>
                                    <col class="rma-kv-col-label" />
                                    <col class="rma-kv-col-value" />
                                    <col class="rma-kv-col-label" />
                                    <col class="rma-kv-col-value" />
                                    <col class="rma-kv-col-label" />
                                    <col class="rma-kv-col-value" />
                                  </colgroup>
                                  <tbody>
                                    <tr>
                                      <td class="rma-kv-label">临时处理方案</td>
                                      <td class="rma-kv-value rma-kv-pre" colspan="5">{{ detailEngineeringReadonlyPerFb[fi].plan || '—' }}</td>
                                    </tr>
                                    <tr v-if="detailEngineeringReadonlyPerFb[fi].files && detailEngineeringReadonlyPerFb[fi].files.length">
                                      <td class="rma-kv-label">方案附件</td>
                                      <td class="rma-kv-value" colspan="5">
                                        <div class="rma-uploads">
                                          <div v-for="(pic, pidx) in detailEngineeringReadonlyPerFb[fi].files" :key="(pic.fileGuids || pic.guid || pic.id || pidx) + '-' + pidx" class="rma-thumb rma-thumb--rounded">
                                            <img :src="rmaAttachmentImgSrc(pic)" :alt="pic.fileName || '图片'" @click="openRmaAttachmentPreview(pic)" />
                                          </div>
                                        </div>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </Panel>
                        </Collapse>
                        <div v-if="detailShowEngineeringWorkflow" class="rma-wf2-footer">
                          <FormItem label="工艺处置结论" prop="engineeringDisposalConclusionType" required>
                            <Select v-model="wf2.engineeringDisposalConclusionType" transfer style="width: 220px" placeholder="必选">
                              <Option v-for="o in (initOptions.engineeringDisposalConclusions || [])" :key="o.value" :value="o.value">{{ o.text }}</Option>
                            </Select>
                          </FormItem>
                        </div>
                      </Form>
                    </div>

                    <div v-if="detailQualityReadonlyVisible" class="rma-ops rma-detail-kv-readonly">
                      <div class="rma-section-head rma-section-head--inset">品质确认</div>
                      <table class="rma-native-table rma-detail-kv-table">
                        <colgroup>
                          <col class="rma-kv-col-label" />
                          <col class="rma-kv-col-value" />
                          <col class="rma-kv-col-label" />
                          <col class="rma-kv-col-value" />
                          <col class="rma-kv-col-label" />
                          <col class="rma-kv-col-value" />
                        </colgroup>
                        <tbody>
                          <tr>
                            <td class="rma-kv-label">确认物料状态</td>
                            <td class="rma-kv-value rma-kv-pre" colspan="5">{{ detailQualityMaterialStatus || '—' }}</td>
                          </tr>
                          <tr v-for="(rowCells, ri) in detailQualityMainKvRowCells" :key="'qf-' + ri">
                            <td v-for="(td, ti) in rowCells" :key="'qf-' + ri + '-' + ti" :class="td.type === 'label' ? 'rma-kv-label' : 'rma-kv-value'">
                              <template v-if="td.type === 'label'">{{ td.text }}</template>
                              <span v-else-if="td.type === 'text'" :class="{ 'rma-kv-pre': td.pre }">{{ td.text }}</span>
                            </td>
                          </tr>
                          <tr>
                            <td class="rma-kv-label">附件</td>
                            <td class="rma-kv-value" colspan="5">
                              <div v-if="detailOrder.qualityPhotoFiles && detailOrder.qualityPhotoFiles.length" class="rma-uploads">
                                <div v-for="(pic, pidx) in detailOrder.qualityPhotoFiles" :key="'q' + (pic.guid || pic.fileGuids || pic.id || pidx)" class="rma-thumb rma-thumb--rounded">
                                  <img :src="rmaAttachmentImgSrc(pic)" @click="openRmaAttachmentPreview(pic)" />
                                </div>
                              </div>
                              <template v-else>—</template>
                            </td>
                          </tr>
                          <tr>
                            <td class="rma-kv-label">品质部接收人</td>
                            <td class="rma-kv-value">{{ detailQualityFillUser }}</td>
                            <td class="rma-kv-label">品质部接收时间</td>
                            <td class="rma-kv-value" colspan="3">{{ detailQualityFillTime }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    <div v-if="detailEngineeringReadonlyVisible" class="rma-ops rma-detail-kv-readonly">
                      <div class="rma-section-head rma-section-head--inset">工艺提交方案</div>
                      <!-- <p v-if="detailFeedBacks.length && detailEngineeringReadonlyAnyPerFb" class="rma-engineering-readonly-note">按项填写的临时方案与附件已在上方「不合格项」各条中展示。</p> -->
                      <table v-if="detailEngineeringPlanText !== '—'" class="rma-native-table rma-detail-kv-table">
                        <colgroup>
                          <col class="rma-kv-col-label" />
                          <col class="rma-kv-col-value" />
                          <col class="rma-kv-col-label" />
                          <col class="rma-kv-col-value" />
                          <col class="rma-kv-col-label" />
                          <col class="rma-kv-col-value" />
                        </colgroup>
                        <tbody>
                          <tr>
                            <td class="rma-kv-label">临时处理方案</td>
                            <td class="rma-kv-value rma-kv-pre" colspan="5">{{ detailEngineeringPlanText }}</td>
                          </tr>
                        </tbody>
                      </table>
                      <table class="rma-native-table rma-detail-kv-table">
                        <colgroup>
                          <col class="rma-kv-col-label" />
                          <col class="rma-kv-col-value" />
                          <col class="rma-kv-col-label" />
                          <col class="rma-kv-col-value" />
                          <col class="rma-kv-col-label" />
                          <col class="rma-kv-col-value" />
                        </colgroup>
                        <tbody>
                          <tr>
                            <td class="rma-kv-label">工艺处置结论</td>
                            <td class="rma-kv-value" colspan="5">{{ detailEngineeringDisposalText }}</td>
                          </tr>
                          <tr>
                            <td class="rma-kv-label">工艺部处理人</td>
                            <td class="rma-kv-value">{{ detailEngineeringPersonName }}</td>
                            <td class="rma-kv-label">工艺部处理时间</td>
                            <td class="rma-kv-value" colspan="3">{{ detailEngineeringFillTimeText }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    <div v-if="detailLiabilityReadonlyVisible" class="rma-ops rma-detail-kv-readonly">
                      <div class="rma-section-head rma-section-head--inset">责任判定</div>
                      <table class="rma-native-table rma-detail-kv-table rma-detail-liability-kv">
                        <colgroup>
                          <col class="rma-kv-col-label" />
                          <col class="rma-kv-col-value" />
                          <col class="rma-kv-col-label" />
                          <col class="rma-kv-col-value" />
                          <col class="rma-kv-col-label" />
                          <col class="rma-kv-col-value" />
                        </colgroup>
                        <tbody>
                          <tr>
                            <td class="rma-kv-label">责任单位/部门</td>
                            <td class="rma-kv-value rma-kv-pre" colspan="5">{{ detailLiabilityUnitDisplay }}</td>
                          </tr>
                          <tr>
                            <td class="rma-kv-label">责任人</td>
                            <td class="rma-kv-value">{{ detailLiabilityPersonDisplay }}</td>
                            <td class="rma-kv-label">不良类别</td>
                            <td class="rma-kv-value" colspan="3">{{ detailLiabilityCategoryDisplay }}</td>
                          </tr>
                          <tr>
                            <td class="rma-kv-label">补充说明</td>
                            <td class="rma-kv-value rma-kv-pre" colspan="5">{{ detailLiabilitySupplementDisplay }}</td>
                          </tr>
                          <tr>
                            <td class="rma-kv-label">处理人</td>
                            <td class="rma-kv-value">{{ detailLiabilityOperatorNamDisplay }}</td>
                            <td class="rma-kv-label">处理时间</td>
                            <td class="rma-kv-value" colspan="3">{{ detailLiabilityOperateTimeTextDisplay }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    <div v-if="detailShowQualityWorkflow" class="rma-ops rma-wf1">
                      <div class="rma-section-head rma-section-head--inset">品质确认</div>
                      <Form ref="wf1Form" :label-width="120" :model="wf1" :rules="wf1FormRules" label-position="right" class="rma-wf-form">
                        <FormItem label="确认物料状态" prop="qualityConfirmMaterialStatus" required>
                          <Input v-model="wf1.qualityConfirmMaterialStatus" type="textarea" :rows="2" placeholder="必填" />
                        </FormItem>
                        <FormItem label="确认不合格数量" prop="qualityConfirmNonConformingQuantity" required>
                          <InputNumber v-model="wf1.qualityConfirmNonConformingQuantity" :min="0" :max="rmaNcQtyMaxForInputNumber" style="width: 200px" />
                        </FormItem>
                        <FormItem label="确认发货数量" prop="qualityConfirmShipQuantity" required>
                          <InputNumber v-model="wf1.qualityConfirmShipQuantity" :min="0" :max="rmaNcQtyMaxForInputNumber" style="width: 200px" />
                        </FormItem>
                        <FormItem label="处置结论" prop="qualityDisposalConclusionType" required>
                          <Select v-model="wf1.qualityDisposalConclusionType" transfer style="width: 220px" placeholder="必选">
                            <Option :value="1">让步接收</Option>
                            <Option :value="2">退回物料</Option>
                          </Select>
                        </FormItem>
                        <FormItem label="附件">
                          <!-- <FormItem label="附件" prop="qualityPhotoFilesCount" required> -->
                          <div class="rma-uploads">
                            <div v-for="(pic, pidx) in wf1QualityPics" :key="pic.fileGuids" class="rma-thumb rma-thumb--rounded">
                              <img :src="baseUrl + pic.url" @click="openPreview(pic.url)" />
                              <div class="rma-thumb-del-hit" title="删除" @click.stop="removeWf1QualityPic(pidx)">
                                <span class="rma-thumb-del-icon" aria-hidden="true">
                                  <Icon type="md-close" :size="16" />
                                </span>
                              </div>
                            </div>
                            <Upload :key="wf1QualityUploadGuid + '-q'" :show-upload-list="false" :on-success="onWf1QualitySuccess" :on-format-error="onFormatError" :action="qualityUploadAction()"
                              :before-upload="() => newQualityUploadGuid()" accept="image/*" type="drag" class="rma-upload-add">
                              <div class="rma-upload-add-inner">+</div>
                            </Upload>
                          </div>
                        </FormItem>
                      </Form>
                    </div>

                    <div v-if="detailShowLiabilityWorkflow" class="rma-ops rma-wf-liability">
                      <div class="rma-section-head rma-section-head--inset">责任判定</div>
                      <Form ref="wfLiabilityForm" :model="wfLiability" :rules="wfLiabilityFormRules" label-position="top" class="rma-wf-form rma-wf-liability-form">
                        <Row :gutter="12" class="rma-wf-liability-fields-row">
                          <Col :xs="24" :sm="24" :md="8" :lg="8">
                          <FormItem label="责任单位/部门" prop="liabilityUnitOrDept" required>
                            <Input v-model="wfLiability.liabilityUnitOrDept" placeholder="必填" />
                          </FormItem>
                          </Col>
                          <Col :xs="24" :sm="24" :md="8" :lg="8">
                          <FormItem label="责任人" prop="liabilityPerson" required>
                            <Input v-model="wfLiability.liabilityPerson" placeholder="必填" />
                          </FormItem>
                          </Col>
                          <Col :xs="24" :sm="24" :md="8" :lg="8">
                          <FormItem label="不良类别" prop="liabilityDefectCategoryType" required>
                            <Select v-model="wfLiability.liabilityDefectCategoryType" transfer style="width: 100%" placeholder="必选">
                              <Option v-for="o in (initOptions.liabilityDefectCategories || [])" :key="o.value" :value="o.value">{{ o.text }}</Option>
                            </Select>
                          </FormItem>
                          </Col>
                        </Row>
                        <FormItem label="补充说明" prop="liabilitySupplementDescription">
                          <Input v-model="wfLiability.liabilitySupplementDescription" type="textarea" :rows="2" placeholder="选填" />
                        </FormItem>
                      </Form>
                    </div>

                    <template v-if="detailOrder">
                      <div v-if="detailOnsiteWorkflowReadonlyVisible" class="rma-ops rma-wf-process-inline rma-wf-process-inline--readonly">
                        <div class="rma-section-head rma-section-head--inset">现场确认状态</div>
                        <table class="rma-native-table rma-detail-kv-table rma-wf-inline-kv">
                          <colgroup>
                            <col class="rma-kv-col-label" />
                            <col class="rma-kv-col-value" />
                            <col class="rma-kv-col-label" />
                            <col class="rma-kv-col-value" />
                            <col class="rma-kv-col-label" />
                            <col class="rma-kv-col-value" />
                          </colgroup>
                          <tbody>
                            <tr>
                              <td class="rma-kv-label">数量</td>
                              <td class="rma-kv-value" colspan="5">{{ detailOnsiteQuantityDisplay }}</td>
                            </tr>
                            <tr v-if="detailOnsiteMaterialFiles.length">
                              <td class="rma-kv-label">上传相关照片</td>
                              <td class="rma-kv-value" colspan="5">
                                <div class="rma-uploads">
                                  <div v-for="(pic, pidx) in detailOnsiteMaterialFiles" :key="'osm-' + pidx + '-' + (pic.fileGuids || pic.guid)" class="rma-thumb rma-thumb--rounded">
                                    <img :src="rmaAttachmentImgSrc(pic)" :alt="pic.fileName || '附件'" @click="openRmaAttachmentPreview(pic)" />
                                  </div>
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td class="rma-kv-label">处理人</td>
                              <td class="rma-kv-value">{{ workflowRegisterPickFieldDisp(['onsiteOperatorName', 'OnsiteOperatorName']) }}</td>
                              <td class="rma-kv-label">处理时间</td>
                              <td class="rma-kv-value" colspan="3">{{ workflowRegisterPickFieldDisp(['onsiteOperateTimeText', 'OnsiteOperateTimeText']) }}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div v-if="detailWarehouseWorkflowReadonlyVisible" class="rma-ops rma-wf-process-inline rma-wf-process-inline--readonly">
                        <div class="rma-section-head rma-section-head--inset">客退品仓入库</div>
                        <table class="rma-native-table rma-detail-kv-table rma-wf-inline-kv">
                          <colgroup>
                            <col class="rma-kv-col-label" />
                            <col class="rma-kv-col-value" />
                            <col class="rma-kv-col-label" />
                            <col class="rma-kv-col-value" />
                            <col class="rma-kv-col-label" />
                            <col class="rma-kv-col-value" />
                          </colgroup>
                          <tbody>
                            <tr>
                              <td class="rma-kv-label">数量</td>
                              <td class="rma-kv-value" colspan="5">{{ detailWarehouseInboundQuantityDisplay }}</td>
                            </tr>
                            <tr v-if="detailReturnWarehouseInFiles.length">
                              <td class="rma-kv-label">上传相关照片</td>
                              <td class="rma-kv-value" colspan="5">
                                <div class="rma-uploads">
                                  <div v-for="(pic, pidx) in detailReturnWarehouseInFiles" :key="'rwi-' + pidx + '-' + (pic.fileGuids || pic.guid)" class="rma-thumb rma-thumb--rounded">
                                    <img :src="rmaAttachmentImgSrc(pic)" :alt="pic.fileName || '附件'" @click="openRmaAttachmentPreview(pic)" />
                                  </div>
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td class="rma-kv-label">处理人</td>
                              <td class="rma-kv-value">{{ workflowRegisterPickFieldDisp(['warehouseInOperatorName', 'WarehouseInOperatorName']) }}</td>
                              <td class="rma-kv-label">处理时间</td>
                              <td class="rma-kv-value" colspan="3">{{ workflowRegisterPickFieldDisp(['warehouseInOperateTimeText', 'WarehouseInOperateTimeText']) }}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div v-if="detailReplenishmentWorkflowReadonlyVisible" class="rma-ops rma-wf-process-inline rma-wf-process-inline--readonly">
                        <div class="rma-section-head rma-section-head--inset">补货处理</div>
                        <table class="rma-native-table rma-detail-kv-table rma-wf-inline-kv">
                          <colgroup>
                            <col class="rma-kv-col-label" />
                            <col class="rma-kv-col-value" />
                            <col class="rma-kv-col-label" />
                            <col class="rma-kv-col-value" />
                            <col class="rma-kv-col-label" />
                            <col class="rma-kv-col-value" />
                          </colgroup>
                          <tbody>
                            <tr v-if="detailReplenishmentReadonlyKv.length >= 2">
                              <td class="rma-kv-label">{{ detailReplenishmentReadonlyKv[0].label }}</td>
                              <td class="rma-kv-value">{{ detailReplenishmentReadonlyKv[0].value }}</td>
                              <td class="rma-kv-label">{{ detailReplenishmentReadonlyKv[1].label }}</td>
                              <td class="rma-kv-value" colspan="3">{{ detailReplenishmentReadonlyKv[1].value }}</td>
                            </tr>
                            <tr>
                              <td class="rma-kv-label">处理人</td>
                              <td class="rma-kv-value">{{ workflowRegisterPickFieldDisp(['replenishmentOperatorName', 'ReplenishmentOperatorName']) }}</td>
                              <td class="rma-kv-label">处理时间</td>
                              <td class="rma-kv-value" colspan="3">{{ workflowRegisterPickFieldDisp(['replenishmentOperateTimeText', 'ReplenishmentOperateTimeText']) }}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div v-if="detailReturnWorkflowReadonlyVisible" class="rma-ops rma-wf-process-inline rma-wf-process-inline--readonly">
                        <div class="rma-section-head rma-section-head--inset">退货处理</div>
                        <table class="rma-native-table rma-detail-kv-table rma-wf-inline-kv">
                          <colgroup>
                            <col class="rma-kv-col-label" />
                            <col class="rma-kv-col-value" />
                            <col class="rma-kv-col-label" />
                            <col class="rma-kv-col-value" />
                            <col class="rma-kv-col-label" />
                            <col class="rma-kv-col-value" />
                          </colgroup>
                          <tbody>
                            <tr v-if="detailReturnReadonlyKv.length >= 2">
                              <td class="rma-kv-label">{{ detailReturnReadonlyKv[0].label }}</td>
                              <td class="rma-kv-value">{{ detailReturnReadonlyKv[0].value }}</td>
                              <td class="rma-kv-label">{{ detailReturnReadonlyKv[1].label }}</td>
                              <td class="rma-kv-value" colspan="3">{{ detailReturnReadonlyKv[1].value }}</td>
                            </tr>
                            <tr>
                              <td class="rma-kv-label">处理人</td>
                              <td class="rma-kv-value">{{ workflowRegisterPickFieldDisp(['returnOperatorName', 'ReturnOperatorName']) }}</td>
                              <td class="rma-kv-label">处理时间</td>
                              <td class="rma-kv-value" colspan="3">{{ workflowRegisterPickFieldDisp(['returnOperateTimeText', 'ReturnOperateTimeText']) }}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>

                      <div v-if="detailShowWorkflowOnSite" id="rma-detail-wf-onsite" class="rma-ops rma-wf-process-inline">
                        <div class="rma-section-head rma-section-head--inset">现场确认状态</div>
                        <Form ref="wfInlineOnSiteForm" :label-width="120" :model="wfInline" :rules="wfInlineOnSiteFormRules" label-position="right" class="rma-wf-form">
                          <FormItem label="数量" prop="onSiteConfirmQuantity" required>
                            <InputNumber v-model="wfInline.onSiteConfirmQuantity" :min="0" :max="rmaNcQtyMaxForInputNumber" style="width: 200px" placeholder="请输入" />
                          </FormItem>
                          <FormItem label="上传相关照片" prop="onSiteMaterialFilesCount" required>
                            <div class="rma-uploads">
                              <div v-for="(pic, pidx) in wfOnSitePics" :key="'wfo-' + (pic.fileGuids || '') + '-' + pidx" class="rma-thumb rma-thumb--rounded">
                                <img :src="wfInlineWorkflowPicSrc(pic)" alt="" @click="openWorkflowInlinePicPreview(pic)" />
                                <div class="rma-thumb-del-hit" title="删除" @click.stop="removeWorkflowInlinePic('onSite', pidx)">
                                  <span class="rma-thumb-del-icon" aria-hidden="true">
                                    <Icon type="md-close" :size="16" />
                                  </span>
                                </div>
                              </div>
                              <Upload :key="wfOnSiteUploadGuid + '-d-os'" class="rma-pic-uploader" :show-upload-list="false" :action="detailWorkflowOnSiteUploadAction" accept="image/*"
                                :on-success="(res, file) => onWorkflowInlinePicSuccess('onSite', res, file)" :before-upload="beforeDetailWorkflowOnSiteUpload" :on-error="onWorkflowInlinePicError"
                                :on-format-error="onFormatErrorDetailWorkflow">
                                <div class="rma-pic-add" title="上传材料附件">
                                  <Icon type="md-add" :size="22" class="rma-pic-add-ico" />
                                  <span class="rma-pic-add-t">上传</span>
                                </div>
                              </Upload>
                            </div>
                          </FormItem>
                        </Form>
                      </div>

                      <div v-if="detailShowWorkflowWarehouseIn" id="rma-detail-wf-wh" class="rma-ops rma-wf-process-inline">
                        <div class="rma-section-head rma-section-head--inset">客退品仓入库</div>
                        <Form ref="wfInlineWarehouseForm" :label-width="120" :model="wfInline" :rules="wfInlineWarehouseFormRules" label-position="right" class="rma-wf-form">
                          <FormItem label="数量" prop="warehouseInboundQuantity" required>
                            <InputNumber v-model="wfInline.warehouseInboundQuantity" :min="0" :max="rmaNcQtyMaxForInputNumber" style="width: 200px" placeholder="请输入" />
                          </FormItem>
                          <FormItem label="上传相关照片" prop="warehouseInFilesCount" required>
                            <div class="rma-uploads">
                              <div v-for="(pic, pidx) in wfWarehousePics" :key="'wfw-' + (pic.fileGuids || '') + '-' + pidx" class="rma-thumb rma-thumb--rounded">
                                <img :src="wfInlineWorkflowPicSrc(pic)" alt="" @click="openWorkflowInlinePicPreview(pic)" />
                                <div class="rma-thumb-del-hit" title="删除" @click.stop="removeWorkflowInlinePic('warehouse', pidx)">
                                  <span class="rma-thumb-del-icon" aria-hidden="true">
                                    <Icon type="md-close" :size="16" />
                                  </span>
                                </div>
                              </div>
                              <Upload :key="wfWarehouseUploadGuid + '-d-wh'" class="rma-pic-uploader" :show-upload-list="false" :action="detailWorkflowWarehouseUploadAction" accept="image/*"
                                :on-success="(res, file) => onWorkflowInlinePicSuccess('warehouse', res, file)" :before-upload="beforeDetailWorkflowWarehouseUpload" :on-error="onWorkflowInlinePicError"
                                :on-format-error="onFormatErrorDetailWorkflow">
                                <div class="rma-pic-add" title="上传入库附件">
                                  <Icon type="md-add" :size="22" class="rma-pic-add-ico" />
                                  <span class="rma-pic-add-t">上传</span>
                                </div>
                              </Upload>
                            </div>
                          </FormItem>
                        </Form>
                      </div>

                      <div v-if="detailShowWorkflowReplenishment" id="rma-detail-wf-rep" class="rma-ops rma-wf-process-inline">
                        <div class="rma-section-head rma-section-head--inset">补货处理</div>
                        <Form ref="wfInlineReplenishmentForm" :label-width="120" :model="wfInline" :rules="wfInlineReplenishmentFormRules" label-position="right" class="rma-wf-form">
                          <FormItem label="补货数量" prop="replenishmentQuantity" required>
                            <InputNumber v-model="wfInline.replenishmentQuantity" :min="0" :max="rmaNcQtyMaxForInputNumber" style="width: 200px" placeholder="请输入" />
                          </FormItem>
                          <FormItem label="完成日期" prop="replenishmentCompleteDate" required>
                            <DatePicker :value="wfInline.replenishmentCompleteDate" type="date" style="width: 220px" format="yyyy-MM-dd" placeholder="请选择" transfer @on-change="onWfInlineReplenishmentDate" />
                          </FormItem>
                        </Form>
                      </div>

                      <div v-if="detailShowWorkflowReturn" id="rma-detail-wf-ret" class="rma-ops rma-wf-process-inline">
                        <div class="rma-section-head rma-section-head--inset">退货处理</div>
                        <Form ref="wfInlineReturnForm" :label-width="120" :model="wfInline" :rules="wfInlineReturnFormRules" label-position="right" class="rma-wf-form">
                          <FormItem label="退货数量" prop="returnProcessQuantity" required>
                            <InputNumber v-model="wfInline.returnProcessQuantity" :min="0" :max="rmaNcQtyMaxForInputNumber" style="width: 200px" placeholder="请输入" />
                          </FormItem>
                          <FormItem label="完成日期" prop="returnProcessCompleteDate" required>
                            <DatePicker :value="wfInline.returnProcessCompleteDate" type="date" style="width: 220px" format="yyyy-MM-dd" placeholder="请选择" transfer @on-change="onWfInlineReturnDate" />
                          </FormItem>
                        </Form>
                      </div>
                    </template>

                    <!-- <div v-if="statusNum(detailOrder.status) === rmaOrderStatus.PENDING_QUALITY_FINALIZE" class="rma-ops rma-wf3">
                      <div class="rma-section-head rma-section-head--inset">品质结案</div>
                      <p class="rma-hint">确认无误后，请在底部点击「品质结案」完成流程。</p>
                    </div> -->
                  </div>
                </TabPane>
                <TabPane label="操作日志" name="log">
                  <table class="rma-native-table rma-detail-log-table">
                    <thead>
                      <tr>
                        <th>时间</th>
                        <th>操作人</th>
                        <th>动作</th>
                        <th>说明</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(log, li) in detailBusinessLogs" :key="'log-' + (log.id != null ? log.id : li)">
                        <td>{{ log.time || '—' }}</td>
                        <td>{{ log.operator || '—' }}</td>
                        <td>{{ log.action || '—' }}</td>
                        <td class="rma-kv-value">{{ log.remark || '—' }}</td>
                      </tr>
                      <tr v-if="!detailBusinessLogs.length">
                        <td colspan="4" class="rma-table-empty">无</td>
                      </tr>
                    </tbody>
                  </table>
                </TabPane>
              </Tabs>
            </div>
          </div>
        </div>
        <div slot="footer" class="rma-detail-modal-footer">
          <template v-if="detailOrder">
            <Button v-if="detailShowDelete" type="error" :loading="deleting" @click="confirmDelete">删除单据</Button>
            <Button v-if="detailShowQualityWorkflow" type="primary" :loading="wfLoading" @click="submitWf1">提交品质确认</Button>
            <Button v-if="detailShowEngineeringWorkflow" type="primary" :loading="wfLoading" @click="submitWf2">提交工艺方案</Button>
            <Button v-if="detailShowLiabilityWorkflow" type="primary" :loading="wfLoading" @click="submitWf3">责任判定</Button>
            <Button v-if="detailShowWorkflowOnSite" type="primary" :loading="wfInlineSubmitting" @click="submitDetailWorkflowSegment('onSite')">提交现场确认</Button>
            <Button v-if="detailShowWorkflowWarehouseIn" type="primary" :loading="wfInlineSubmitting" @click="submitDetailWorkflowSegment('warehouse')">提交客退入库</Button>
            <Button v-if="detailShowWorkflowReplenishment" type="primary" :loading="wfInlineSubmitting" @click="submitDetailWorkflowSegment('replenishment')">提交补货处理</Button>
            <Button v-if="detailShowWorkflowReturn" type="primary" :loading="wfInlineSubmitting" @click="submitDetailWorkflowSegment('return')">提交退货处理</Button>
          </template>
          <Button @click="closeDetailModal">关闭</Button>
        </div>
      </Modal>
    </Card>
  </div>
</template>

<script>
import RMAOrderCreateForm from './RMAOrderCreateForm.vue'
import RMAOrderPrint from './print'
import {
  RMA_ORDER_STATUS,
  RMA_ORDER_STATUS_TAG_COLOR,
  RMA_ORDER_STATUS_FALLBACK_TEXT,
} from './rmaOrderConstants'
import {
  rmaIsShowEdit,
  rmaIsShowProcessInList,
  rmaIsShowQualityReceive,
  rmaIsShowEngineeringProcess,
  rmaIsShowDelete,
  rmaIsShowLiabilityJudgment,
} from './rmaOrderFlags'
import {
  getOnsiteConfirmMaterialFilesArray,
  getReturnWarehouseInFilesArray,
  mapPictureFilesToWorkflowPics,
  rmaPickFirstNum,
  rmaPickFirstRaw,
  rmaSegmentEditable,
  rmaSegmentHasSubmittedData,
} from './rmaWorkflowSegmentUtils'

const API = '/api/services/app/RMA_Order'

export default {
  name: 'RMAOrder',
  components: {
    RMAOrderCreateForm,
    RMAOrderPrint,
  },
  data() {
    return {
      /** 主单状态枚举，供模板 v-if 与表格 render 使用 */
      rmaOrderStatus: RMA_ORDER_STATUS,
      listLoading: false,
      list: [],
      detailLoading: false,
      totalCount: 0,
      currentPage: 1,
      pageSize: 10,
      wf1QualityUploadGuid: '',
      listQuery: {
        recordNumber: '',
        customerName: '',
        status: null,
        causeDepartment: null,
      },
      initOptions: {
        causeDepartments: [],
        documentCopyTypes: [],
        orderStatuses: [],
        qualityDisposalConclusions: [],
        engineeringDisposalConclusions: [],
        feedBackLineStatuses: [],
        liabilityDefectCategories: [],
      },
      detailOrder: null,
      deleting: false,
      wfLoading: false,
      isFixedDepartment: false,
      wf1: {
        qualityConfirmMaterialStatus: '',
        qualityConfirmNonConformingQuantity: null,
        qualityConfirmShipQuantity: null,
        qualityDisposalConclusionType: null,
        /** 与 wf1QualityPics.length 同步，仅用于 Form 校验 */
        qualityPhotoFilesCount: 0,
      },
      wf1QualityPics: [],
      wf2: {
        engineeringDisposalConclusionType: null,
        engineeringPersonUserId: null,
        /** 工艺提交：每条不合格项一条方案 + 可选附件（与 Form 校验 prop 路径 feedBackPlans.i.* 对应） */
        feedBackPlans: [],
      },
      wfLiability: {
        liabilityUnitOrDept: '',
        liabilityPerson: '',
        liabilityDefectCategoryType: null,
        liabilitySupplementDescription: '',
      },
      createModalShow: false,
      /** 新建为 null；编辑时为单据 id，与 RMAOrderCreateForm 同步 */
      createEditId: null,
      /** 子流程办理入口：仅展示对应 isShow 块；null 表示普通「编辑」展示全部 */
      createWorkflowFocus: null,
      /** 详情内联办理：四段子流程草稿（对照 RMAOrderCreateForm.workflow 字段） */
      wfInline: {
        onSiteConfirmQuantity: null,
        onSiteMaterialFilesCount: 0,
        warehouseInboundQuantity: null,
        warehouseInFilesCount: 0,
        replenishmentQuantity: null,
        replenishmentCompleteDate: null,
        returnProcessQuantity: null,
        returnProcessCompleteDate: null,
      },
      wfOnSitePics: [],
      wfWarehousePics: [],
      wfOnSiteUploadGuid: '',
      wfWarehouseUploadGuid: '',
      wfInlineSubmitting: false,
      /** 详情弹窗：从列表「处理」进入时为 process，标题为「处理不良品处理单」 */
      detailModalPurpose: 'browse',
      detailModalVisible: false,
      /** 当前详情弹窗对应的单据 id（不写入路由） */
      detailOpenId: null,
      /** 详情内「详情 / 操作日志」Tab */
      detailInfoTab: 'base',
      /** 不合格项折叠面板：已展开项的 name 列表 */
      detailFbActiveKeys: [],
      /**
       * 列表点击「现场确认状态 / 客退品仓入库 / 补货处理 / 退货处理」进入详情时记录子流程段；
       * 为 onSite | warehouse | replenishment | return 时，详情内子流程区仅展示该段对应的办理表单（隐藏同区其它块）。
       */
      detailWorkflowListFocusSegment: null,
      printModalShow: false,
      isShowPrint: false,
      printOrderId: null,
    }
  },
  computed: {
    detailFeedBacks() {
      if (!this.detailOrder) return []
      return this.detailOrder.feedBacks || this.detailOrder.feedBackLines || []
    },
    /** 详情只读：现场确认材料附件 */
    detailOnsiteMaterialFiles() {
      return getOnsiteConfirmMaterialFilesArray(this.detailOrder)
    },
    /** 详情只读：客退品仓入库附件 */
    detailReturnWarehouseInFiles() {
      return getReturnWarehouseInFilesArray(this.detailOrder)
    },
    /** 由列表办理入口限定：仅展示某一子流程办理区 */
    detailWorkflowListSegmentOnlyMode() {
      const s = this.detailWorkflowListFocusSegment
      return s === 'onSite' || s === 'warehouse' || s === 'replenishment' || s === 'return'
    },
    detailShowWorkflowOnSite() {
      const base = this.detailOrder ? rmaSegmentEditable(this.detailOrder, 'onSite') : false
      if (!this.detailWorkflowListSegmentOnlyMode) return base
      return this.detailWorkflowListFocusSegment === 'onSite' && base
    },
    detailShowWorkflowWarehouseIn() {
      const base = this.detailOrder ? rmaSegmentEditable(this.detailOrder, 'warehouse') : false
      if (!this.detailWorkflowListSegmentOnlyMode) return base
      return this.detailWorkflowListFocusSegment === 'warehouse' && base
    },
    detailShowWorkflowReplenishment() {
      const base = this.detailOrder ? rmaSegmentEditable(this.detailOrder, 'replenishment') : false
      if (!this.detailWorkflowListSegmentOnlyMode) return base
      return this.detailWorkflowListFocusSegment === 'replenishment' && base
    },
    detailShowWorkflowReturn() {
      const base = this.detailOrder ? rmaSegmentEditable(this.detailOrder, 'return') : false
      if (!this.detailWorkflowListSegmentOnlyMode) return base
      return this.detailWorkflowListFocusSegment === 'return' && base
    },
    /** 子流程四段（现场确认/客退入库/补货/退货）：状态 ≥ 处理中(27) 时才按「已填写」展示只读详情（与品质/工艺/责任逻辑分离，不修改后者） */
    detailInSubWorkflowPhase() {
      if (!this.detailOrder) return false
      return this.statusNum(this.detailOrder.status) >= RMA_ORDER_STATUS.IN_PROGRESS
    },
    detailOnsiteWorkflowHasData() {
      return this.detailOrder ? rmaSegmentHasSubmittedData(this.detailOrder, 'onSite') : false
    },
    detailWarehouseWorkflowHasData() {
      return this.detailOrder ? rmaSegmentHasSubmittedData(this.detailOrder, 'warehouse') : false
    },
    detailReplenishmentWorkflowHasData() {
      return this.detailOrder
        ? rmaSegmentHasSubmittedData(this.detailOrder, 'replenishment')
        : false
    },
    detailReturnWorkflowHasData() {
      return this.detailOrder ? rmaSegmentHasSubmittedData(this.detailOrder, 'return') : false
    },
    detailOnsiteWorkflowReadonlyVisible() {
      if (
        this.detailWorkflowListSegmentOnlyMode &&
        this.detailWorkflowListFocusSegment !== 'onSite'
      ) {
        return false
      }
      return this.detailInSubWorkflowPhase && this.detailOnsiteWorkflowHasData
    },
    detailWarehouseWorkflowReadonlyVisible() {
      if (
        this.detailWorkflowListSegmentOnlyMode &&
        this.detailWorkflowListFocusSegment !== 'warehouse'
      ) {
        return false
      }
      return this.detailInSubWorkflowPhase && this.detailWarehouseWorkflowHasData
    },
    detailReplenishmentWorkflowReadonlyVisible() {
      if (
        this.detailWorkflowListSegmentOnlyMode &&
        this.detailWorkflowListFocusSegment !== 'replenishment'
      ) {
        return false
      }
      return this.detailInSubWorkflowPhase && this.detailReplenishmentWorkflowHasData
    },
    detailReturnWorkflowReadonlyVisible() {
      if (
        this.detailWorkflowListSegmentOnlyMode &&
        this.detailWorkflowListFocusSegment !== 'return'
      ) {
        return false
      }
      return this.detailInSubWorkflowPhase && this.detailReturnWorkflowHasData
    },
    detailOnsiteQuantityDisplay() {
      const d = this.detailOrder
      if (!d) return '—'
      const q = rmaPickFirstNum(d, [
        'onsiteConfirmQuantity',
        'OnsiteConfirmQuantity',
        'onSiteConfirmationQuantity',
        'OnSiteConfirmQuantity',
      ])
      return q !== null && !Number.isNaN(q) ? String(q) : '—'
    },
    detailWarehouseInboundQuantityDisplay() {
      const d = this.detailOrder
      if (!d) return '—'
      const q = rmaPickFirstNum(d, [
        'returnWarehouseInQuantity',
        'ReturnWarehouseInQuantity',
        'warehouseInboundQuantity',
        'customerReturnWarehouseInboundQuantity',
        'WarehouseInboundQuantity',
      ])
      return q !== null && !Number.isNaN(q) ? String(q) : '—'
    },
    /** 新增时填报的不合格数量（与 RMAOrderCreateForm 中 nonConformingQuantity 一致），处理环节各数量不可超过此值 */
    detailOriginalNonConformingQtyCap() {
      const d = this.detailOrder
      if (!d) return null
      const q = rmaPickFirstNum(d, ['nonConformingQuantity', 'NonConformingQuantity'])
      if (q === null || Number.isNaN(q)) return null
      return q >= 0 ? q : null
    },
    /** InputNumber 有 cap 时传 :max，无则 undefined 表示不限制 */
    rmaNcQtyMaxForInputNumber() {
      const c = this.detailOriginalNonConformingQtyCap
      return c == null ? undefined : c
    },
    /** Form 校验：数量不得大于单据上的不合格数量 */
    wfQtyLeOriginalNcRule() {
      return {
        validator: (rule, value, callback) => {
          const cap = this.detailOriginalNonConformingQtyCap
          if (cap == null || value === null || value === undefined || value === '') {
            callback()
            return
          }
          const n = Number(value)
          if (Number.isNaN(n)) {
            callback()
            return
          }
          if (n > cap) {
            callback(new Error(`不能超过新增时填报的不合格数量（${cap}）`))
          } else {
            callback()
          }
        },
        trigger: 'change',
      }
    },
    detailReplenishmentReadonlyKv() {
      const d = this.detailOrder
      if (!d) return []
      const q = rmaPickFirstNum(d, [
        'replenishmentQuantity',
        'replenishmentProcessQuantity',
        'ReplenishmentQuantity',
      ])
      const qty = q !== null && !Number.isNaN(q) ? String(q) : '—'
      let dateText = '—'
      for (const k of [
        'replenishmentCompleteDate',
        'replenishmentProcessCompleteDate',
        'ReplenishmentCompleteDate',
        'replenishmentCompletedTime',
        'ReplenishmentCompletedTime',
      ]) {
        if (!Object.prototype.hasOwnProperty.call(d, k)) continue
        const raw = d[k]
        if (raw == null || raw === '') continue
        if (typeof raw === 'string') {
          dateText =
            raw.length >= 10 && /^\d{4}-\d{2}-\d{2}/.test(raw.trim())
              ? raw.trim().slice(0, 10)
              : raw.trim()
          break
        }
        if (typeof this.$moment === 'function') {
          const m = this.$moment(raw)
          dateText = m.isValid() ? m.format('YYYY-MM-DD') : String(raw)
        } else {
          dateText = String(raw)
        }
        break
      }
      return [
        { label: '补货数量', value: qty },
        { label: '完成日期', value: dateText },
      ]
    },
    detailReturnReadonlyKv() {
      const d = this.detailOrder
      if (!d) return []
      const q = rmaPickFirstNum(d, [
        'returnQuantity',
        'ReturnQuantity',
        'returnProcessQuantity',
        'returnHandlingQuantity',
        'ReturnProcessQuantity',
      ])
      const qty = q !== null && !Number.isNaN(q) ? String(q) : '—'
      let dateText = '—'
      for (const k of [
        'returnProcessCompleteDate',
        'returnHandlingCompleteDate',
        'ReturnProcessCompleteDate',
        'returnCompletedTime',
        'ReturnCompletedTime',
      ]) {
        if (!Object.prototype.hasOwnProperty.call(d, k)) continue
        const raw = d[k]
        if (raw == null || raw === '') continue
        if (typeof raw === 'string') {
          dateText =
            raw.length >= 10 && /^\d{4}-\d{2}-\d{2}/.test(raw.trim())
              ? raw.trim().slice(0, 10)
              : raw.trim()
          break
        }
        if (typeof this.$moment === 'function') {
          const m = this.$moment(raw)
          dateText = m.isValid() ? m.format('YYYY-MM-DD') : String(raw)
        } else {
          dateText = String(raw)
        }
        break
      }
      return [
        { label: '退货数量', value: qty },
        { label: '完成日期', value: dateText },
      ]
    },
    /** 操作日志：GetOrderDetail.businessLogDtos */
    detailBusinessLogs() {
      if (!this.detailOrder) return []
      const raw = this.detailOrder.businessLogDtos || this.detailOrder.BusinessLogDtos || []
      if (!Array.isArray(raw)) return []
      const fmtTime = (row) => {
        const text = row.creationTimeText || row.CreationTimeText
        if (text != null && String(text).trim()) return String(text).trim()
        const ct = row.creationTime != null ? row.creationTime : row.CreationTime
        if (ct == null || ct === '') return ''
        if (typeof ct === 'string') {
          const s = ct.trim()
          return s.indexOf('T') > -1 ? s.replace('T', ' ').replace(/\.\d+.*$/, '') : s
        }
        if (ct && ct.toString) return ct.toString()
        return String(ct)
      }
      return raw.map((row) => ({
        id: row.id != null ? row.id : row.Id,
        time: fmtTime(row) || '—',
        operator: row.creatorName != null ? row.creatorName : row.CreatorName || '—',
        action: row.content != null ? row.content : row.Content || '—',
        remark: (() => {
          const d = row.description != null ? row.description : row.Description
          return d != null && String(d) !== '' ? String(d) : '—'
        })(),
      }))
    },
    /** 品质部已提交后（状态 > 待品质部接收）展示只读确认信息 */
    detailQualityReadonlyVisible() {
      if (!this.detailOrder) return false
      return this.statusNum(this.detailOrder.status) > RMA_ORDER_STATUS.PENDING_QUALITY_RECEIVE
    },
    detailQualityMaterialStatus() {
      const d = this.detailOrder
      if (!d) return ''
      const s = d.qualityConfirmMaterialStatus
      return s != null && String(s).trim() ? String(s).trim() : ''
    },
    detailQualityDisposalText() {
      const d = this.detailOrder
      if (!d) return '—'
      const text = d.qualityDisposalConclusionTypeText
      if (text) return text
      const t = d.qualityDisposalConclusionType
      if (t === null || t === undefined || t === '') return '—'
      return (
        this.selText(this.initOptions.qualityDisposalConclusions, t) ||
        (t === 1 ? '让步接收' : t === 2 ? '退回物料' : String(t))
      )
    },
    /** 详情中是否包含工艺提交内容（主单/子行/feedBackTreatmentPlans） */
    detailEngineeringHasData() {
      if (!this.detailOrder) return false
      const d = this.detailOrder
      const t = d.engineeringDisposalConclusionType
      const hasConclusion = t !== null && t !== undefined && t !== ''
      if (hasConclusion) return true
      const plan = d.temporaryTreatmentPlan
      if (plan != null && String(plan).trim()) return true
      const rawPlans = d.feedBackTreatmentPlans || d.FeedBackTreatmentPlans
      if (Array.isArray(rawPlans) && rawPlans.length) return true
      const fbs = this.detailFeedBacks
      for (let i = 0; i < fbs.length; i++) {
        const fb = fbs[i]
        const p =
          fb.temporaryTreatmentPlan ||
          fb.TemporaryTreatmentPlan ||
          fb.engineeringTemporaryTreatmentPlan
        if (p != null && String(p).trim()) return true
        const files = fb.engineeringPlanFiles || fb.EngineeringPlanFiles
        if (Array.isArray(files) && files.length) return true
      }
      return false
    },
    /**
     * 工艺只读：与 detailFeedBacks 下标对齐，每项 { plan, files } 或 null（供折叠面板内展示）
     * 兼容主单 feedBackTreatmentPlans、子行字段、旧版整单 temporaryTreatmentPlan（挂第一条）
     */
    detailEngineeringReadonlyPerFb() {
      const fbs = this.detailFeedBacks
      const n = fbs.length
      if (!this.detailOrder || !n || !this.detailEngineeringReadonlyVisible) {
        return []
      }
      const d = this.detailOrder
      const out = []
      const rawPlans = d.feedBackTreatmentPlans || d.FeedBackTreatmentPlans
      if (Array.isArray(rawPlans) && rawPlans.length) {
        rawPlans.forEach((p) => {
          const fbId = p.feedBackId != null ? p.feedBackId : p.FeedBackId
          const fi = fbs.findIndex((f) => {
            const rawId =
              f.id != null ? f.id : f.feedBackId != null ? f.feedBackId : f.feedBackLineId
            return Number(rawId) === Number(fbId)
          })
          if (fi >= 0) {
            const planRaw =
              p.temporaryTreatmentPlan != null ? p.temporaryTreatmentPlan : p.TemporaryTreatmentPlan
            const planStr = planRaw != null && String(planRaw).trim() ? String(planRaw).trim() : '—'
            const files = p.engineeringPlanFiles || p.EngineeringPlanFiles || []
            out[fi] = { plan: planStr, files: Array.isArray(files) ? files : [] }
          }
        })
        return out
      }
      let any = false
      fbs.forEach((fb, fi) => {
        const plan =
          fb.temporaryTreatmentPlan ||
          fb.TemporaryTreatmentPlan ||
          fb.engineeringTemporaryTreatmentPlan ||
          ''
        const files = fb.engineeringPlanFiles || fb.EngineeringPlanFiles || []
        const hasPlan = plan != null && String(plan).trim() !== ''
        const hasFiles = Array.isArray(files) && files.length > 0
        if (hasPlan || hasFiles) {
          out[fi] = {
            plan: hasPlan ? String(plan).trim() : '—',
            files: Array.isArray(files) ? files : [],
          }
          any = true
        }
      })
      if (any) return out
      const legacy = d.temporaryTreatmentPlan
      if (legacy != null && String(legacy).trim()) {
        out[0] = { plan: String(legacy).trim(), files: [] }
      }
      return out
    },
    /** 是否存在任一项的只读工艺方案（用于提示文案，避免仅有结论时误提示） */
    detailEngineeringReadonlyAnyPerFb() {
      const arr = this.detailEngineeringReadonlyPerFb
      for (let i = 0; i < arr.length; i++) {
        if (arr[i]) return true
      }
      return false
    },
    /** 状态大于待工艺部处理且工艺已填写时展示工艺只读块（如直接让步完结无工艺则不展示） */
    detailEngineeringReadonlyVisible() {
      if (!this.detailOrder) return false
      if (this.statusNum(this.detailOrder.status) <= RMA_ORDER_STATUS.PENDING_ENGINEERING) {
        return false
      }
      return this.detailEngineeringHasData
    },
    detailEngineeringPlanText() {
      const d = this.detailOrder
      if (!d) return '—'
      const p = d.temporaryTreatmentPlan
      return p != null && String(p).trim() ? String(p).trim() : '—'
    },
    detailEngineeringDisposalText() {
      const d = this.detailOrder
      if (!d) return '—'
      const text = d.engineeringDisposalConclusionTypeText
      if (text) return text
      const t = d.engineeringDisposalConclusionType
      if (t === null || t === undefined || t === '') return '—'
      return this.selText(this.initOptions.engineeringDisposalConclusions, t) || String(t)
    },
    /** 工艺部处理人：仅 EngineeringPersonName / engineeringPersonName */
    detailEngineeringPersonName() {
      if (!this.detailOrder) return '—'
      const d = this.detailOrder
      for (const k of ['EngineeringPersonName', 'engineeringPersonName']) {
        if (d[k] != null && String(d[k]).trim()) return String(d[k]).trim()
      }
      return '—'
    },
    /** 工艺部处理时间：仅 EngineeringFillTimeText / engineeringFillTimeText */
    detailEngineeringFillTimeText() {
      if (!this.detailOrder) return '—'
      const d = this.detailOrder
      for (const k of ['EngineeringFillTimeText', 'engineeringFillTimeText']) {
        const raw = d[k]
        if (raw != null && raw !== '') {
          if (typeof raw === 'string') return raw
          if (raw && raw.toString) return raw.toString()
          return String(raw)
        }
      }
      return '—'
    },
    /** 品质确认只读（不含拍照、不含确认物料状态）：确认物料状态在模板中独占一行；其余每行 3 组 */
    detailQualityMainKvRowCells() {
      if (!this.detailQualityReadonlyVisible || !this.detailOrder) return []
      const d = this.detailOrder
      const items = [
        {
          label: '确认不合格数量',
          text: this.detailFmtNum(d.qualityConfirmNonConformingQuantity),
        },
        {
          label: '确认发货数量',
          text: this.detailFmtNum(d.qualityConfirmShipQuantity),
        },
        { label: '处置结论', text: this.detailQualityDisposalText },
      ]
      const rows = []
      for (let i = 0; i < items.length; i += 3) {
        const chunk = items.slice(i, i + 3)
        while (chunk.length < 3) {
          chunk.push({ label: '', text: '', pad: true })
        }
        const cells = []
        for (const item of chunk) {
          cells.push({ type: 'label', text: item.label })
          if (item.pad) {
            cells.push({ type: 'text', text: '', pre: false })
          } else {
            cells.push({ type: 'text', text: item.text, pre: !!item.pre })
          }
        }
        rows.push(cells)
      }
      return rows
    },
    /** 品质部接收人（优先 QualitySubmitterName / qualitySubmitterName） */
    detailQualityFillUser() {
      if (!this.detailOrder) return '—'
      const d = this.detailOrder
      for (const k of ['qualitySubmitterName', 'QualitySubmitterName']) {
        if (d[k] != null && String(d[k]).trim()) return String(d[k]).trim()
      }
      const v =
        d.qualityConfirmUserName ||
        d.qualityConfirmFillUserName ||
        d.qualityConfirmationUserName ||
        d.qualityDepartmentConfirmUserName ||
        d.qualityConfirmSubmitterName ||
        d.qualityFillUserName
      return v != null && String(v).trim() ? String(v).trim() : '—'
    },
    /** 品质部接收时间（优先 QualityFillDateText / qualityFillDateText） */
    detailQualityFillTime() {
      if (!this.detailOrder) return '—'
      const d = this.detailOrder
      for (const k of ['qualityFillDateText', 'QualityFillDateText']) {
        const raw = d[k]
        if (raw != null && raw !== '') {
          if (typeof raw === 'string') return raw
          if (raw && raw.toString) return raw.toString()
          return String(raw)
        }
      }
      const t =
        d.qualityConfirmTime ||
        d.qualityConfirmationTime ||
        d.qualityDepartmentConfirmTime ||
        d.qualityFillTime ||
        d.qualityConfirmCreationTime
      if (t == null || t === '') return '—'
      if (typeof t === 'string') return t
      if (t && t.toString) return t.toString()
      return String(t)
    },
    /** 详情内可填写品质确认（由后端 IsShow品质部接收 等控制） */
    detailShowQualityWorkflow() {
      if (!this.detailOrder) return false
      return (
        this.statusNum(this.detailOrder.status) === RMA_ORDER_STATUS.PENDING_QUALITY_RECEIVE &&
        rmaIsShowQualityReceive(this.detailOrder)
      )
    },
    /** 详情内可填写工艺方案（由后端 IsShow工艺部处理 等控制） */
    detailShowEngineeringWorkflow() {
      if (!this.detailOrder) return false
      return (
        this.statusNum(this.detailOrder.status) === RMA_ORDER_STATUS.PENDING_ENGINEERING &&
        rmaIsShowEngineeringProcess(this.detailOrder)
      )
    },
    /** 详情内可删除（待品质部接收 + 后端 IsShow删除） */
    detailShowDelete() {
      if (!this.detailOrder) return false
      return rmaIsShowDelete(this.detailOrder)
    },
    /** 主单责任三项是否至少一项有实质内容（仅补充说明不算） */
    detailLiabilityHasSubmittedData() {
      if (!this.detailOrder) return false
      const d = this.detailOrder
      const dept = d.liabilityUnitOrDept != null ? d.liabilityUnitOrDept : d.LiabilityUnitOrDept
      const person = d.liabilityPerson != null ? d.liabilityPerson : d.LiabilityPerson
      const t =
        d.liabilityDefectCategoryType !== undefined && d.liabilityDefectCategoryType !== null
          ? d.liabilityDefectCategoryType
          : d.LiabilityDefectCategoryType
      const hasDept = dept != null && String(dept).trim() !== ''
      const hasPerson = person != null && String(person).trim() !== ''
      const hasType = t !== null && t !== undefined && t !== ''
      return hasDept || hasPerson || hasType
    },
    /** 结案后只读展示责任判定（>25 且三项之一有值） */
    detailLiabilityReadonlyVisible() {
      if (!this.detailOrder) return false
      if (this.statusNum(this.detailOrder.status) <= RMA_ORDER_STATUS.PENDING_QUALITY_FINALIZE) {
        return false
      }
      return this.detailLiabilityHasSubmittedData
    },
    /** 待品质责任判定 + 后端展示责任判定 */
    detailShowLiabilityWorkflow() {
      if (!this.detailOrder) return false
      return (
        this.statusNum(this.detailOrder.status) === RMA_ORDER_STATUS.PENDING_QUALITY_FINALIZE &&
        rmaIsShowLiabilityJudgment(this.detailOrder)
      )
    },
    detailLiabilityUnitDisplay() {
      const d = this.detailOrder
      if (!d) return '—'
      const v = d.liabilityUnitOrDept != null ? d.liabilityUnitOrDept : d.LiabilityUnitOrDept
      return v != null && String(v).trim() ? String(v).trim() : '—'
    },
    detailLiabilityPersonDisplay() {
      const d = this.detailOrder
      if (!d) return '—'
      const v = d.liabilityPerson != null ? d.liabilityPerson : d.LiabilityPerson
      return v != null && String(v).trim() ? String(v).trim() : '—'
    },
    detailLiabilityOperateTimeTextDisplay() {
      const d = this.detailOrder
      if (!d) return '—'
      const v =
        d.liabilityOperateTimeText != null ? d.liabilityOperateTimeText : d.liabilityOperateTimeText
      return v != null && String(v).trim() ? String(v).trim() : '—'
    },
    detailLiabilityOperatorNamDisplay() {
      const d = this.detailOrder
      if (!d) return '—'
      const v = d.liabilityOperatorName != null ? d.liabilityOperatorName : d.liabilityOperatorName
      return v != null && String(v).trim() ? String(v).trim() : '—'
    },
    detailLiabilityCategoryDisplay() {
      const d = this.detailOrder
      if (!d) return '—'
      const text =
        d.liabilityDefectCategoryTypeText != null
          ? d.liabilityDefectCategoryTypeText
          : d.LiabilityDefectCategoryTypeText
      if (text != null && String(text).trim()) return String(text).trim()
      const t =
        d.liabilityDefectCategoryType !== undefined && d.liabilityDefectCategoryType !== null
          ? d.liabilityDefectCategoryType
          : d.LiabilityDefectCategoryType
      if (t === null || t === undefined || t === '') return '—'
      return this.selText(this.initOptions.liabilityDefectCategories, t) || String(t)
    },
    detailLiabilitySupplementDisplay() {
      const d = this.detailOrder
      if (!d) return '—'
      const v =
        d.liabilitySupplementDescription != null
          ? d.liabilitySupplementDescription
          : d.LiabilitySupplementDescription
      return v != null && String(v).trim() ? String(v).trim() : '—'
    },
    /** 详情内联子流程上传地址（guid 每次加载详情重置） */
    detailWorkflowOnSiteUploadAction() {
      const base = typeof abp !== 'undefined' && abp && abp.url ? abp.url : this.baseUrl
      return `${base}/file/UploadByRMA_OrderOnsiteConfirm?guid=${this.wfOnSiteUploadGuid}`
    },
    detailWorkflowWarehouseUploadAction() {
      const base = typeof abp !== 'undefined' && abp && abp.url ? abp.url : this.baseUrl
      return `${base}/file/UploadByRMA_OrderWarehouseIn?guid=${this.wfWarehouseUploadGuid}`
    },
    detailModalTitle() {
      if (this.detailModalPurpose === 'process') {
        return '处理不良品处理单'
      }
      return this.detailOrder && this.detailOrder.recordNumber
        ? `不良品处理单 — ${this.detailOrder.recordNumber}`
        : '不良品处理单详情'
    },
    baseUrl() {
      return this.$constDefinition.baseUrl
    },
    /** 工艺环节：每项临时处理方案必填 + 工艺处置结论必选 */
    wf2FormRules() {
      if (!this.detailShowEngineeringWorkflow) {
        return {}
      }
      const rules = {
        engineeringDisposalConclusionType: [
          {
            validator: (rule, value, callback) => {
              if (value === null || value === undefined || value === '') {
                callback(new Error('请选择工艺处置结论'))
              } else {
                callback()
              }
            },
            trigger: 'change',
          },
        ],
      }
      const plans = (this.wf2 && this.wf2.feedBackPlans) || []
      for (let i = 0; i < plans.length; i++) {
        rules['feedBackPlans.' + i + '.temporaryTreatmentPlan'] = [
          {
            validator: (rule, value, callback) => {
              if (value == null || String(value).trim() === '') {
                callback(new Error('请填写临时处理方案'))
              } else {
                callback()
              }
            },
            trigger: 'blur',
          },
        ]
      }
      return rules
    },
    wf1FormRules() {
      const numRequired = (msg) => ({
        validator(rule, value, callback) {
          if (value === null || value === undefined || value === '') {
            callback(new Error(msg))
          } else {
            callback()
          }
        },
        trigger: 'change',
      })
      const leNc = this.wfQtyLeOriginalNcRule
      return {
        qualityConfirmMaterialStatus: [
          {
            validator: (rule, value, callback) => {
              if (!value || !String(value).trim()) {
                callback(new Error('请填写确认物料状态'))
              } else {
                callback()
              }
            },
            trigger: 'blur',
          },
        ],
        qualityConfirmNonConformingQuantity: [numRequired('请填写确认不合格数量'), leNc],
        qualityConfirmShipQuantity: [numRequired('请填写确认发货数量'), leNc],
        qualityDisposalConclusionType: [
          {
            validator: (rule, value, callback) => {
              if (value === null || value === undefined || value === '') {
                callback(new Error('请选择处置结论'))
              } else {
                callback()
              }
            },
            trigger: 'change',
          },
        ],
        qualityPhotoFilesCount: [
          {
            validator: (rule, value, callback) => {
              if (!this.wf1QualityPics.length) {
                callback(new Error('请上传拍照（质量部）'))
              } else {
                callback()
              }
            },
            trigger: 'change',
          },
        ],
      }
    },
    wfLiabilityFormRules() {
      if (!this.detailShowLiabilityWorkflow) {
        return {}
      }
      return {
        liabilityUnitOrDept: [
          {
            validator: (rule, value, callback) => {
              if (!value || !String(value).trim()) {
                callback(new Error('请填写责任单位/部门'))
              } else {
                callback()
              }
            },
            trigger: 'blur',
          },
        ],
        liabilityPerson: [
          {
            validator: (rule, value, callback) => {
              if (!value || !String(value).trim()) {
                callback(new Error('请填写责任人'))
              } else {
                callback()
              }
            },
            trigger: 'blur',
          },
        ],
        liabilityDefectCategoryType: [
          {
            validator: (rule, value, callback) => {
              if (value === null || value === undefined || value === '') {
                callback(new Error('请选择不良类别'))
              } else {
                callback()
              }
            },
            trigger: 'change',
          },
        ],
      }
    },
    wfInlineOnSiteFormRules() {
      const numRequired = (msg) => ({
        validator(rule, value, callback) {
          if (
            value === null ||
            value === undefined ||
            value === '' ||
            (typeof value === 'number' && Number.isNaN(value))
          ) {
            callback(new Error(msg))
          } else {
            callback()
          }
        },
        trigger: 'change',
      })
      const leNc = this.wfQtyLeOriginalNcRule
      return {
        onSiteConfirmQuantity: [numRequired('请填写现场确认的数量'), leNc],
        onSiteMaterialFilesCount: [
          {
            validator: (rule, value, callback) => {
              if (!this.wfOnSitePics.length) {
                callback(new Error('请上传至少一件现场确认附件'))
              } else {
                callback()
              }
            },
            trigger: 'change',
          },
        ],
      }
    },
    wfInlineWarehouseFormRules() {
      const numRequired = (msg) => ({
        validator(rule, value, callback) {
          if (
            value === null ||
            value === undefined ||
            value === '' ||
            (typeof value === 'number' && Number.isNaN(value))
          ) {
            callback(new Error(msg))
          } else {
            callback()
          }
        },
        trigger: 'change',
      })
      const leNc = this.wfQtyLeOriginalNcRule
      return {
        warehouseInboundQuantity: [numRequired('请填写客退品仓入库的数量'), leNc],
        warehouseInFilesCount: [
          {
            validator: (rule, value, callback) => {
              if (!this.wfWarehousePics.length) {
                callback(new Error('请上传至少一件客退品仓入库附件'))
              } else {
                callback()
              }
            },
            trigger: 'change',
          },
        ],
      }
    },
    wfInlineReplenishmentFormRules() {
      const numRequired = (msg) => ({
        validator(rule, value, callback) {
          if (
            value === null ||
            value === undefined ||
            value === '' ||
            (typeof value === 'number' && Number.isNaN(value))
          ) {
            callback(new Error(msg))
          } else {
            callback()
          }
        },
        trigger: 'change',
      })
      const leNc = this.wfQtyLeOriginalNcRule
      return {
        replenishmentQuantity: [numRequired('请填写补货处理的补货数量'), leNc],
        replenishmentCompleteDate: [
          {
            validator: (rule, value, callback) => {
              if (value == null || String(value).trim() === '') {
                callback(new Error('请选择补货处理的完成日期'))
              } else {
                callback()
              }
            },
            trigger: 'change',
          },
        ],
      }
    },
    wfInlineReturnFormRules() {
      const numRequired = (msg) => ({
        validator(rule, value, callback) {
          if (
            value === null ||
            value === undefined ||
            value === '' ||
            (typeof value === 'number' && Number.isNaN(value))
          ) {
            callback(new Error(msg))
          } else {
            callback()
          }
        },
        trigger: 'change',
      })
      const leNc = this.wfQtyLeOriginalNcRule
      return {
        returnProcessQuantity: [numRequired('请填写退货数量'), leNc],
        returnProcessCompleteDate: [
          {
            validator: (rule, value, callback) => {
              if (value == null || String(value).trim() === '') {
                callback(new Error('请选择退货处理的完成日期'))
              } else {
                callback()
              }
            },
            trigger: 'change',
          },
        ],
      }
    },
    tableColumns() {
      const self = this
      return [
        { title: '记录编号', key: 'recordNumber', minWidth: 140, ellipsis: true },
        { title: '客户', key: 'customerName', minWidth: 100 },
        { title: '物料', key: 'materialName', minWidth: 100 },
        {
          title: '状态',
          key: 'status',
          minWidth: 120,
          render: (h, p) => h('span', self.statusText(p.row)),
        },
        { title: '创建时间', key: 'creationTimeText', minWidth: 160, ellipsis: true },
        {
          title: '操作',
          key: '_op',
          width: 300,
          align: 'left',
          render(h, p) {
            const row = p.row
            const canDel = rmaIsShowDelete(row)
            const showEdit = rmaIsShowEdit(row)
            const showProcess = rmaIsShowProcessInList(row)
            const showLiabilityJudge = rmaIsShowLiabilityJudgment(row)
            const lf = { margin: '5px' }
            const btns = []
            if (showProcess) {
              btns.push(
                h(
                  'Button',
                  {
                    props: { type: 'warning', size: 'small' },
                    on: { click: () => self.goDetail(row.id, { process: true }) },
                  },
                  '处理'
                )
              )
            } else if (showLiabilityJudge) {
              btns.push(
                h(
                  'Button',
                  {
                    props: { type: 'warning', size: 'small' },
                    on: { click: () => self.goDetail(row.id) },
                  },
                  '责任判断'
                )
              )
            } else {
              btns.push(
                h(
                  'Button',
                  {
                    props: { type: 'primary', size: 'small' },
                    on: { click: () => self.goDetail(row.id) },
                  },
                  '详情'
                )
              )
            }
            if (row.isShow打印RMA单 === true) {
              btns.push(
                h(
                  'Button',
                  {
                    props: { type: 'warning', size: 'small' },
                    style: lf,
                    on: { click: () => self.onListPrintRma(row) },
                  },
                  '打印RMA单'
                )
              )
            }
            /** 列表行若为 QueryDto 精简字段，可能缺少附件/数量；此时无法判定「已提交」，办理按钮仍以 isShow 为准（详见 rmaWorkflowSegmentUtils） */
            if (rmaSegmentEditable(row, 'onSite')) {
              btns.push(
                h(
                  'Button',
                  {
                    props: { type: 'warning', size: 'small' },
                    style: lf,
                    on: { click: () => self.goDetail(row.id, { workflowSegment: 'onSite' }) },
                  },
                  '现场确认状态'
                )
              )
            }
            if (rmaSegmentEditable(row, 'warehouse')) {
              btns.push(
                h(
                  'Button',
                  {
                    props: { type: 'warning', size: 'small' },
                    style: lf,
                    on: { click: () => self.goDetail(row.id, { workflowSegment: 'warehouse' }) },
                  },
                  '客退品仓入库'
                )
              )
            }
            if (rmaSegmentEditable(row, 'replenishment')) {
              btns.push(
                h(
                  'Button',
                  {
                    props: { type: 'warning', size: 'small' },
                    style: lf,
                    on: {
                      click: () => self.goDetail(row.id, { workflowSegment: 'replenishment' }),
                    },
                  },
                  '补货处理'
                )
              )
            }
            if (rmaSegmentEditable(row, 'return')) {
              btns.push(
                h(
                  'Button',
                  {
                    props: { type: 'warning', size: 'small' },
                    style: lf,
                    on: { click: () => self.goDetail(row.id, { workflowSegment: 'return' }) },
                  },
                  '退货处理'
                )
              )
            }
            if (showEdit) {
              btns.push(
                h(
                  'Button',
                  {
                    props: { type: 'default', size: 'small' },
                    style: lf,
                    on: { click: () => self.openEditRow(row) },
                  },
                  '编辑'
                )
              )
            }
            if (canDel) {
              btns.push(
                h(
                  'Button',
                  {
                    props: { type: 'error', size: 'small' },
                    style: lf,
                    on: { click: () => self.deleteRow(row) },
                  },
                  '删除'
                )
              )
            }
            return h('div', btns)
          },
        },
      ]
    },
    /** 详情 Tab 主表：每行 3 组「标签 + 值」，原生表格用 */
    detailInfoKvRows() {
      if (!this.detailOrder) return []
      const d = this.detailOrder
      const label = (k) => {
        const m = {
          recordNumber: '记录编号',
          formNumber: '表单编号',
          causeDepartment: '事业部',
          customerName: '客户名称',
          materialName: '物料名称',
          specificationModel: '规格型号',
          drawingOrCustomerMaterialCode: '图号/客户料号',
          kingdeeCode: '金蝶编码',
          reportingDepartment: '通报部门',
          occurrenceTimeText: '异常发生时间',
          responsibleUnitOrDept: '责任单位/部门',
          responsiblePerson: '责任人',
          batchQuantity: '批量数量',
          nonConformingQuantity: '不良数量',
          salesSubmitterName: '销售填表人',
          salesFillTimeText: '销售填表时间',
          status: '状态',
        }
        return m[k] || k
      }
      const fmt = (k, v) => {
        if (k === 'causeDepartment')
          return (
            d.causeDepartmentText || this.selText(this.initOptions.causeDepartments, v) || v || ''
          )
        if (k === 'status') return d.statusText || this.statusText(d)
        if (v == null || v === '') return ''
        if (k === 'occurrenceTimeText' || k === 'salesFillTimeText') {
          if (typeof v === 'string') return v
          if (v && v.toString) return v.toString()
        }
        return v
      }
      const keys = [
        'recordNumber',
        'formNumber',
        'causeDepartment',
        'customerName',
        'materialName',
        'specificationModel',
        'drawingOrCustomerMaterialCode',
        'kingdeeCode',
        'reportingDepartment',
        'occurrenceTimeText',
        'responsibleUnitOrDept',
        'responsiblePerson',
        'batchQuantity',
        'nonConformingQuantity',
        'salesSubmitterName',
        'salesFillTimeText',
        'status',
      ]
      const flat = keys.map((k) => {
        const v = fmt(k, d[k])
        return { label: label(k), value: v === '' || v == null ? '—' : String(v) }
      })
      const rows = []
      for (let i = 0; i < flat.length; i += 3) {
        const chunk = flat.slice(i, i + 3)
        while (chunk.length < 3) {
          chunk.push({ label: '', value: '' })
        }
        rows.push(chunk)
      }
      return rows
    },
    /** 每行 6 个 td：标签、值交替，供原生表格渲染 */
    detailInfoKvRowCells() {
      return this.detailInfoKvRows.map((cells) =>
        cells.flatMap((c) => [
          { kind: 'label', text: c.label },
          { kind: 'value', text: c.value },
        ])
      )
    },
    detailStatusTagColor() {
      if (!this.detailOrder) return 'default'
      const s = this.statusNum(this.detailOrder.status)
      return RMA_ORDER_STATUS_TAG_COLOR[s] || 'default'
    },
  },
  watch: {
    $route: {
      handler(route) {
        const path = (route.path || '').toLowerCase()
        if (path.endsWith('rd')) {
          this.listQuery.causeDepartment = 3
          this.isFixedDepartment = true
        } else if (path.endsWith('oem') || path.endsWith('ome')) {
          this.listQuery.causeDepartment = 2
          this.isFixedDepartment = true
        } else {
          this.isFixedDepartment = false
        }
      },
      immediate: true,
    },
    createModalShow(val) {
      if (!val) this.createWorkflowFocus = null
    },
  },
  async mounted() {
    await this.loadInit()
    await this.loadList()
    const q = this.$route.query
    if (q.create === '1' || q.create === 'true') {
      const nextQuery = { ...q }
      delete nextQuery.create
      this.$router.replace({ name: 'rmaOrder', query: nextQuery })
      this.$nextTick(() => this.openCreateModal())
    }
  },
  methods: {
    /**
     * 解析 ABP/axios 响应体：`const { data } = await this.$Ajax.get/post` 中 `data` 等于 response.data
     * 标准 ABP 为 `{ result, success, ... }`；无 result 时视为已是业务 JSON（如你方约定直接返回 DTO）
     */
    parseAbpData(httpBody) {
      if (httpBody == null) return null
      if (Object.prototype.hasOwnProperty.call(httpBody, 'result')) return httpBody.result
      return httpBody
    },
    detailFmtNum(v) {
      if (v === null || v === undefined || v === '') return '—'
      return String(v)
    },
    selText(list, value) {
      if (!list || value == null) return ''
      const f = list.find((x) => x.value === value)
      return f ? f.text : ''
    },
    statusNum(s) {
      if (s == null) return -1
      return Number(s)
    },
    statusText(row) {
      if (!row) return '—'
      if (row.statusText) return row.statusText
      const s = this.statusNum(row.status)
      const t = (this.initOptions.orderStatuses || []).find((o) => o.value === s)
      if (t) return t.text
      return RMA_ORDER_STATUS_FALLBACK_TEXT[s] || String(row.status)
    },
    async loadInit() {
      try {
        const { data } = await this.$Ajax.get(`${API}/GetMgrInitData`)
        const r = this.parseAbpData(data) || {}
        this.initOptions = {
          causeDepartments: r.causeDepartments || [],
          documentCopyTypes: r.documentCopyTypes || [],
          orderStatuses: r.orderStatuses || [],
          qualityDisposalConclusions: r.qualityDisposalConclusions || [],
          engineeringDisposalConclusions: r.engineeringDisposalConclusions || [],
          feedBackLineStatuses: r.feedBackLineStatuses || [],
          liabilityDefectCategories:
            r.liabilityDefectCategories || r.LiabilityDefectCategories || [],
        }
      } catch (e) {
        this.$Message.error('获取初始化数据失败，请检查权限与接口')
      }
    },
    async loadList(p) {
      if (p === 1) this.currentPage = 1
      this.listLoading = true
      try {
        const body = {
          recordNumber: this.listQuery.recordNumber || undefined,
          customerName: this.listQuery.customerName || undefined,
          status:
            this.listQuery.status == null || this.listQuery.status === ''
              ? undefined
              : this.listQuery.status,
          causeDepartment:
            this.listQuery.causeDepartment == null || this.listQuery.causeDepartment === ''
              ? undefined
              : this.listQuery.causeDepartment,
          skipCount: (this.currentPage - 1) * this.pageSize,
          maxResultCount: this.pageSize,
          sorting: 'creationTime desc',
        }
        const { data } = await this.$Ajax.post(`${API}/QueryDto`, body)
        const r = this.parseAbpData(data) || {}
        this.list = r.items || []
        this.totalCount = r.totalCount != null ? r.totalCount : 0
      } catch (e) {
        this.list = []
        this.totalCount = 0
      } finally {
        this.listLoading = false
      }
    },
    onPage(p) {
      this.currentPage = p
      this.loadList()
    },
    onPageSize(s) {
      this.pageSize = s
      this.loadList(1)
    },
    closeDetailModal() {
      this.detailModalVisible = false
    },
    onDetailModalVisibleChange(visible) {
      if (visible) return
      this.detailModalPurpose = 'browse'
      this.detailWorkflowListFocusSegment = null
      this.detailInfoTab = 'base'
      this.detailFbActiveKeys = []
      this.resetDetailUiState()
      this.detailOrder = null
      this.detailOpenId = null
    },
    resetDetailUiState() {
      this.wf1 = {
        qualityConfirmMaterialStatus: '',
        qualityConfirmNonConformingQuantity: null,
        qualityConfirmShipQuantity: null,
        qualityDisposalConclusionType: null,
        qualityPhotoFilesCount: 0,
      }
      this.wf1QualityPics = []
      this.wf2 = {
        engineeringDisposalConclusionType: null,
        engineeringPersonUserId: null,
        feedBackPlans: [],
      }
      this.wfLiability = {
        liabilityUnitOrDept: '',
        liabilityPerson: '',
        liabilityDefectCategoryType: null,
        liabilitySupplementDescription: '',
      }
      this.wfInline = {
        onSiteConfirmQuantity: null,
        onSiteMaterialFilesCount: 0,
        warehouseInboundQuantity: null,
        warehouseInFilesCount: 0,
        replenishmentQuantity: null,
        replenishmentCompleteDate: null,
        returnProcessQuantity: null,
        returnProcessCompleteDate: null,
      }
      this.wfOnSitePics = []
      this.wfWarehousePics = []
      this.wfOnSiteUploadGuid = ''
      this.wfWarehouseUploadGuid = ''
      this.wfInlineSubmitting = false
    },
    /** 根据详情不合格项初始化工艺编辑行（在 loadDetail 成功写入 detailOrder 后调用） */
    initWf2FeedBackPlansFromDetail() {
      this.wf2.feedBackPlans = []
      if (!this.detailOrder) return
      const fbs = this.detailOrder.feedBacks || this.detailOrder.feedBackLines || []
      this.wf2.feedBackPlans = fbs.map((fb) => {
        const rawId =
          fb.id != null ? fb.id : fb.feedBackId != null ? fb.feedBackId : fb.feedBackLineId
        const feedBackId = Number(rawId)
        return {
          feedBackId: Number.isNaN(feedBackId) ? 0 : feedBackId,
          temporaryTreatmentPlan: '',
          pics: [],
          _uploadGuid: this.createGuid(),
        }
      })
    },
    fbPanelKey(fb, fi) {
      return fb.id != null ? `fb-${fb.id}` : `fb-i-${fi}`
    },
    initDetailFbCollapse() {
      const list = this.detailFeedBacks
      this.detailFbActiveKeys = list.map((fb, fi) => this.fbPanelKey(fb, fi))
    },
    workflowFormatDateYmdFromRaw(raw) {
      if (raw == null || raw === '') return null
      const m = this.$moment(raw)
      return m.isValid() ? m.format('YYYY-MM-DD') : null
    },
    /** 从 GetOrderDetail 回填详情内联子流程表单 */
    initWorkflowInlineFromDetail() {
      const d = this.detailOrder
      if (!d) return
      const wf = this.wfInline
      wf.onSiteConfirmQuantity = rmaPickFirstNum(d, [
        'onsiteConfirmQuantity',
        'OnsiteConfirmQuantity',
        'onSiteConfirmationQuantity',
        'OnSiteConfirmQuantity',
      ])
      wf.warehouseInboundQuantity = rmaPickFirstNum(d, [
        'returnWarehouseInQuantity',
        'ReturnWarehouseInQuantity',
        'warehouseInboundQuantity',
        'customerReturnWarehouseInboundQuantity',
        'WarehouseInboundQuantity',
      ])
      wf.replenishmentQuantity = rmaPickFirstNum(d, [
        'replenishmentQuantity',
        'replenishmentProcessQuantity',
        'ReplenishmentQuantity',
      ])
      wf.returnProcessQuantity = rmaPickFirstNum(d, [
        'returnQuantity',
        'ReturnQuantity',
        'returnProcessQuantity',
        'returnHandlingQuantity',
        'ReturnProcessQuantity',
      ])
      wf.replenishmentCompleteDate = this.workflowFormatDateYmdFromRaw(
        rmaPickFirstRaw(d, [
          'replenishmentCompleteDate',
          'replenishmentProcessCompleteDate',
          'ReplenishmentCompleteDate',
          'replenishmentCompletedTime',
          'ReplenishmentCompletedTime',
        ])
      )
      wf.returnProcessCompleteDate = this.workflowFormatDateYmdFromRaw(
        rmaPickFirstRaw(d, [
          'returnProcessCompleteDate',
          'returnHandlingCompleteDate',
          'ReturnProcessCompleteDate',
          'returnCompletedTime',
          'ReturnCompletedTime',
        ])
      )
      this.wfOnSitePics = mapPictureFilesToWorkflowPics(
        d.onsiteConfirmMaterialFiles ||
          d.OnsiteConfirmMaterialFiles ||
          d.onSiteConfirmPictureFiles ||
          d.onSiteConfirmationPictureFiles ||
          d.onSiteConfirmPictureFileList ||
          []
      )
      this.wfWarehousePics = mapPictureFilesToWorkflowPics(
        d.returnWarehouseInFiles ||
          d.ReturnWarehouseInFiles ||
          d.warehouseInboundPictureFiles ||
          d.customerReturnWarehouseInboundPictureFiles ||
          d.warehouseInboundPictureFileList ||
          []
      )
      this.wfOnSiteUploadGuid = this.createGuid()
      this.wfWarehouseUploadGuid = this.createGuid()
      this.syncWfInlinePicCounts()
      this.clampWorkflowQuantitiesToOriginalNonConforming()
    },
    clampWorkflowQuantitiesToOriginalNonConforming() {
      const cap = this.detailOriginalNonConformingQtyCap
      if (cap == null) return
      const clampObj = (obj, keys) => {
        keys.forEach((key) => {
          const v = obj[key]
          if (v == null || v === '') return
          const n = Number(v)
          if (Number.isNaN(n)) return
          if (n > cap) obj[key] = cap
        })
      }
      clampObj(this.wf1, ['qualityConfirmNonConformingQuantity', 'qualityConfirmShipQuantity'])
      clampObj(this.wfInline, [
        'onSiteConfirmQuantity',
        'warehouseInboundQuantity',
        'replenishmentQuantity',
        'returnProcessQuantity',
      ])
    },
    workflowRegisterPickField(candidates) {
      const d = this.detailOrder
      if (!d || !candidates || !candidates.length) return ''
      for (let i = 0; i < candidates.length; i++) {
        const k = candidates[i]
        if (!Object.prototype.hasOwnProperty.call(d, k)) continue
        const v = d[k]
        if (v == null || v === '') continue
        if (typeof v === 'string') return v.trim()
        if (
          v instanceof Date ||
          (typeof v === 'object' && v !== null && typeof v.getTime === 'function')
        ) {
          const m = this.$moment(v)
          return m.isValid() ? m.format('YYYY-MM-DD HH:mm:ss') : String(v)
        }
        const s = typeof v.toString === 'function' ? v.toString().trim() : String(v)
        if (/^\d{4}-\d{2}-\d{2}T/.test(s)) {
          const m = this.$moment(s)
          return m.isValid() ? m.format('YYYY-MM-DD HH:mm:ss') : s
        }
        return s
      }
      return ''
    },
    workflowRegisterPickFieldDisp(candidates) {
      const v = this.workflowRegisterPickField(candidates)
      return v === '' || v == null ? '—' : v
    },
    mapWorkflowFilesForApiDetail(pics) {
      return (pics || []).map((p) => ({
        fileGuids: p.fileGuids || p.guid,
        fileName: (p.fileName && String(p.fileName).trim()) || undefined,
        url: p.url != null && p.url !== '' ? p.url : undefined,
      }))
    },
    workflowDateYmdToIsoStart(ymd) {
      if (ymd == null || String(ymd).trim() === '') return undefined
      return this.$moment(ymd, 'YYYY-MM-DD').startOf('day').toISOString()
    },
    syncWfInlinePicCounts() {
      this.wfInline.onSiteMaterialFilesCount = this.wfOnSitePics.length
      this.wfInline.warehouseInFilesCount = this.wfWarehousePics.length
    },
    submitDetailWorkflowSegment(seg) {
      if (!this.detailOrder) return
      const refMap = {
        onSite: 'wfInlineOnSiteForm',
        warehouse: 'wfInlineWarehouseForm',
        replenishment: 'wfInlineReplenishmentForm',
        return: 'wfInlineReturnForm',
      }
      const formRef = refMap[seg]
      const form = formRef ? this.$refs[formRef] : null
      if (!form) return
      this.syncWfInlinePicCounts()
      form.validate((valid) => {
        if (!valid) return
        this.runDetailWorkflowSegmentSubmit(seg)
      })
    },
    async runDetailWorkflowSegmentSubmit(seg) {
      if (!this.detailOrder) return
      const id = this.detailOrder.id
      const body = { id }
      const f = this.wfInline
      if (seg === 'onSite') {
        body.IsOnsiteConfirmed = true
        body.onsiteConfirmQuantity = f.onSiteConfirmQuantity
        body.onsiteConfirmMaterialFiles = this.mapWorkflowFilesForApiDetail(this.wfOnSitePics)
      } else if (seg === 'warehouse') {
        body.isReturnWarehouseIn = true
        body.returnWarehouseInQuantity = f.warehouseInboundQuantity
        body.returnWarehouseInFiles = this.mapWorkflowFilesForApiDetail(this.wfWarehousePics)
      } else if (seg === 'replenishment') {
        body.isReplenishmentHandled = true
        body.replenishmentQuantity = f.replenishmentQuantity
        body.replenishmentCompletedTime = this.workflowDateYmdToIsoStart(
          f.replenishmentCompleteDate
        )
      } else if (seg === 'return') {
        body.isReturnHandled = true
        body.returnQuantity = f.returnProcessQuantity
        body.returnCompletedTime = this.workflowDateYmdToIsoStart(f.returnProcessCompleteDate)
      }
      this.wfInlineSubmitting = true
      try {
        await this.$Ajax.post(`${API}/WorkflowReturnProcessUpdate`, body)
        this.$Message.success('提交成功')
        if (
          this.detailWorkflowListFocusSegment != null &&
          this.detailWorkflowListFocusSegment === seg
        ) {
          this.detailWorkflowListFocusSegment = null
        }
        // if (this.detailOpenId != null) await this.loadDetail(this.detailOpenId)
        this.loadList(1)
        this.closeDetailModal()
      } catch (e) {
        /* */
      } finally {
        this.wfInlineSubmitting = false
      }
    },
    /** 列表单段办理进入时，将视口滚到对应表单 */
    scrollDetailWorkflowListFocusIntoView() {
      const map = {
        onSite: 'rma-detail-wf-onsite',
        warehouse: 'rma-detail-wf-wh',
        replenishment: 'rma-detail-wf-rep',
        return: 'rma-detail-wf-ret',
      }
      const domId = map[this.detailWorkflowListFocusSegment]
      if (!domId) return
      this.$nextTick(() => {
        const el = typeof document !== 'undefined' ? document.getElementById(domId) : null
        if (el && typeof el.scrollIntoView === 'function') {
          el.scrollIntoView({ block: 'nearest', behavior: 'smooth' })
        }
      })
    },
    wfInlineWorkflowPicSrc(pic) {
      if (!pic) return ''
      const path = pic.url != null && pic.url !== '' ? pic.url : pic.imageUrl
      if (path == null || path === '') return ''
      const s = String(path).trim()
      if (
        /^https?:\/\//i.test(s) ||
        s.startsWith('//') ||
        s.startsWith('blob:') ||
        s.startsWith('data:')
      ) {
        return s
      }
      return this.baseUrl + (s.startsWith('/') ? s : `/${s}`)
    },
    openWorkflowInlinePicPreview(pic) {
      const href = this.wfInlineWorkflowPicSrc(pic)
      if (href) window.open(href)
    },
    beforeDetailWorkflowOnSiteUpload() {
      this.wfOnSiteUploadGuid = this.createGuid()
      return true
    },
    beforeDetailWorkflowWarehouseUpload() {
      this.wfWarehouseUploadGuid = this.createGuid()
      return true
    },
    onWorkflowInlinePicSuccess(bucket, res, file) {
      const pics = bucket === 'warehouse' ? this.wfWarehousePics : this.wfOnSitePics
      const r0 = res && res.result !== undefined ? res.result : res
      const g =
        (r0 && r0.guid) ||
        (res && res.result && res.result.guid) ||
        (res && res.guid) ||
        (res && res.data && res.data.result && res.data.result.guid)
      let u =
        (r0 && (r0.imageUrl != null && r0.imageUrl !== '' ? r0.imageUrl : r0.url)) ||
        (res && res.imageUrl) ||
        (res && res.data && res.data.result && (res.data.result.imageUrl || res.data.result.url))
      if (!u && file && file.response) {
        const fr = file.response.result !== undefined ? file.response.result : file.response
        u = (fr && (fr.imageUrl || fr.url)) || u
      }
      const fileName = (file && file.name) || (file && file.filename) || undefined
      if (g) pics.push({ fileGuids: g, url: u || '', fileName })
      this.syncWfInlinePicCounts()
      this.$nextTick(() => {
        if (bucket === 'warehouse' && this.$refs.wfInlineWarehouseForm) {
          this.$refs.wfInlineWarehouseForm.validateField('warehouseInFilesCount')
        } else if (bucket === 'onSite' && this.$refs.wfInlineOnSiteForm) {
          this.$refs.wfInlineOnSiteForm.validateField('onSiteMaterialFilesCount')
        }
      })
    },
    removeWorkflowInlinePic(bucket, pidx) {
      if (bucket === 'warehouse') this.wfWarehousePics.splice(pidx, 1)
      else this.wfOnSitePics.splice(pidx, 1)
      this.syncWfInlinePicCounts()
      this.$nextTick(() => {
        if (bucket === 'warehouse' && this.$refs.wfInlineWarehouseForm) {
          this.$refs.wfInlineWarehouseForm.validateField('warehouseInFilesCount')
        } else if (bucket === 'onSite' && this.$refs.wfInlineOnSiteForm) {
          this.$refs.wfInlineOnSiteForm.validateField('onSiteMaterialFilesCount')
        }
      })
    },
    onWorkflowInlinePicError() {
      this.$Message.error('上传失败')
    },
    onFormatErrorDetailWorkflow() {
      this.$Message.warning('文件格式不支持')
    },
    onWfInlineReplenishmentDate(val) {
      if (val == null || val === '') {
        this.wfInline.replenishmentCompleteDate = null
      } else {
        this.wfInline.replenishmentCompleteDate = this.$moment(val).format('YYYY-MM-DD')
      }
      this.$nextTick(() => {
        if (this.$refs.wfInlineReplenishmentForm) {
          this.$refs.wfInlineReplenishmentForm.validateField('replenishmentCompleteDate')
        }
      })
    },
    onWfInlineReturnDate(val) {
      if (val == null || val === '') {
        this.wfInline.returnProcessCompleteDate = null
      } else {
        this.wfInline.returnProcessCompleteDate = this.$moment(val).format('YYYY-MM-DD')
      }
      this.$nextTick(() => {
        if (this.$refs.wfInlineReturnForm) {
          this.$refs.wfInlineReturnForm.validateField('returnProcessCompleteDate')
        }
      })
    },
    openCreateModal() {
      this.createWorkflowFocus = null
      this.createEditId = null
      this.$nextTick(() => {
        this.createModalShow = true
      })
    },
    openEditRow(row, focus = null) {
      if (!row || row.id == null) return
      this.createWorkflowFocus = focus
      this.createEditId = Number(row.id)
      this.$nextTick(() => {
        this.createModalShow = true
      })
    },
    /** 子流程弹窗保存后：刷新列表；若详情仍打开则刷新详情数据 */
    onCreateFormSuccess() {
      this.loadList(1)
      if (this.detailModalVisible && this.detailOpenId != null) {
        this.loadDetail(this.detailOpenId)
      }
    },
    onListPrintRma(row) {
      if (!row || row.id == null) return
      this.printOrderId = Number(row.id)
      this.isShowPrint = true
      this.printModalShow = true
    },
    closeRmaPrintModal() {
      this.printModalShow = false
      this.isShowPrint = false
      this.printOrderId = null
    },
    goDetail(id, opts = {}) {
      this.detailModalPurpose = opts.process ? 'process' : 'browse'
      const ws = opts.workflowSegment
      this.detailWorkflowListFocusSegment =
        ws === 'onSite' || ws === 'warehouse' || ws === 'replenishment' || ws === 'return'
          ? ws
          : null
      this.detailModalVisible = true
      this.loadDetail(id)
    },
    openPreview(path) {
      if (!path) return
      window.open(this.baseUrl + path)
    },
    /** 详情/列表附件：兼容 url、imageUrl、filePath、guid（后端 DTO 多为 guid） */
    rmaAttachmentImgSrc(pic) {
      if (!pic) return ''
      const path =
        (pic.url != null && pic.url !== '' ? pic.url : '') ||
        (pic.imageUrl != null && pic.imageUrl !== '' ? pic.imageUrl : '') ||
        (pic.filePath != null && pic.filePath !== '' ? pic.filePath : '') ||
        (pic.guid ? `/files/previewThumbnail/${pic.guid}` : '') ||
        (pic.fileGuids ? `/files/previewThumbnail/${pic.fileGuids}` : '')
      if (!path) return ''
      const s = String(path).trim()
      if (
        /^https?:\/\//i.test(s) ||
        s.startsWith('//') ||
        s.startsWith('blob:') ||
        s.startsWith('data:')
      ) {
        return s
      }
      return this.baseUrl + (s.startsWith('/') ? s : `/${s}`)
    },
    openRmaAttachmentPreview(pic) {
      let href = this.rmaAttachmentImgSrc(pic)
      if (!href) return
      if (href.indexOf('/previewThumbnail/') > -1) {
        href = href.replace('/previewThumbnail/', '/preview/')
      }
      window.open(href)
    },
    async loadDetail(idOpt) {
      const raw = idOpt != null && idOpt !== '' ? idOpt : this.detailOpenId
      if (raw == null || raw === '') return
      const id = Number(raw)
      if (Number.isNaN(id)) return
      this.detailOpenId = id
      this.detailLoading = true
      this.detailOrder = null
      try {
        const { data } = await this.$Ajax.get(`${API}/GetOrderDetail`, { params: { id } })
        this.detailOrder = this.parseAbpData(data)
        this.resetDetailUiState()
        this.initWf2FeedBackPlansFromDetail()
        this.initWorkflowInlineFromDetail()
        this.$nextTick(() => {
          this.initDetailFbCollapse()
          this.scrollDetailWorkflowListFocusIntoView()
        })
      } catch (e) {
        this.$Message.error('加载详情失败')
      } finally {
        this.detailLoading = false
      }
    },
    confirmDelete() {
      const id = this.detailOrder && this.detailOrder.id
      if (id == null) return
      this.$Modal.confirm({
        title: '确认删除',
        content: '仅「待品质部接收」可删除，确定删除该单据？',
        onOk: () => this.doDelete(Number(id)),
      })
    },
    async doDelete(id) {
      this.deleting = true
      try {
        await this.$Ajax.post(`${API}/DeleteOrder`, { id })
        this.$Message.success('已删除')
        this.closeDetailModal()
        this.loadList(1)
      } catch (e) {
        /* */
      } finally {
        this.deleting = false
      }
    },
    deleteRow(row) {
      this.$Modal.confirm({
        title: '确认删除',
        content: '确定删除该记录？',
        onOk: () => this.doDelete(row.id),
      })
    },
    newQualityUploadGuid() {
      this.wf1QualityUploadGuid = this.createGuid()
      return true
    },
    qualityUploadAction() {
      return `${this.baseUrl}/file/UploadByRMA_Order?guid=${
        this.wf1QualityUploadGuid || this.createGuid()
      }`
    },
    S4() {
      return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1)
    },
    createGuid() {
      return (
        this.S4() +
        this.S4() +
        '-' +
        this.S4() +
        '-' +
        this.S4() +
        '-' +
        this.S4() +
        '-' +
        this.S4() +
        this.S4() +
        this.S4()
      )
    },
    onFormatError() {
      this.$Message.warning('文件格式不支持')
    },
    onWf1QualitySuccess(res) {
      const g = (res && res.result && res.result.guid) || (res && res.guid)
      const u = (res && res.result && res.result.imageUrl) || (res && res.imageUrl)
      if (g) {
        this.wf1QualityPics.push({ fileGuids: g, url: u || '' })
        this.wf1.qualityPhotoFilesCount = this.wf1QualityPics.length
        this.$nextTick(() => {
          if (this.$refs.wf1Form) this.$refs.wf1Form.validateField('qualityPhotoFilesCount')
        })
      }
    },
    removeWf1QualityPic(pidx) {
      this.wf1QualityPics.splice(pidx, 1)
      this.wf1.qualityPhotoFilesCount = this.wf1QualityPics.length
      this.$nextTick(() => {
        if (this.$refs.wf1Form) this.$refs.wf1Form.validateField('qualityPhotoFilesCount')
      })
    },
    beforeWf2PlanUpload(fi) {
      const row = this.wf2.feedBackPlans[fi]
      if (row) row._uploadGuid = this.createGuid()
      return true
    },
    wf2PlanUploadAction(fi) {
      const row = this.wf2.feedBackPlans[fi]
      const g = (row && row._uploadGuid) || this.createGuid()
      return `${this.baseUrl}/file/UploadByRMA_Order?guid=${g}`
    },
    onWf2PlanSuccess(fi, res, file) {
      const g = (res && res.result && res.result.guid) || (res && res.guid)
      const u = (res && res.result && res.result.imageUrl) || (res && res.imageUrl)
      const row = this.wf2.feedBackPlans[fi]
      if (!g || !row) return
      const fileName = (file && file.name) || (file && file.file && file.file.name) || undefined
      row.pics.push({ fileGuids: g, url: u || '', fileName })
    },
    removeWf2PlanPic(fi, pidx) {
      const row = this.wf2.feedBackPlans[fi]
      if (row && row.pics) row.pics.splice(pidx, 1)
    },
    submitWf1() {
      const id = this.detailOrder && this.detailOrder.id
      if (!id) return
      const form = this.$refs.wf1Form
      if (!form) return
      this.wf1.qualityPhotoFilesCount = this.wf1QualityPics.length
      form.validate(async (valid) => {
        if (!valid) return
        this.wfLoading = true
        try {
          const body = {
            id,
            qualityConfirmMaterialStatus:
              (this.wf1.qualityConfirmMaterialStatus || '').trim() || undefined,
            qualityConfirmNonConformingQuantity: this.wf1.qualityConfirmNonConformingQuantity,
            qualityConfirmShipQuantity: this.wf1.qualityConfirmShipQuantity,
            qualityDisposalConclusionType: this.wf1.qualityDisposalConclusionType,
            qualityPhotoFiles: this.wf1QualityPics.map((p) => ({
              fileGuids: p.fileGuids || p.guid,
            })),
          }
          await this.$Ajax.post(`${API}/WorkflowQualityConfirm`, body)
          this.$Message.success('已提交')
          await this.loadDetail()
          this.loadList()
        } catch (e) {
          /* */
        } finally {
          this.wfLoading = false
        }
      })
    },
    async submitWf2() {
      const plans = this.wf2.feedBackPlans || []
      if (!plans.length) {
        this.$Message.warning('无不合格项，无法提交工艺方案')
        return
      }
      for (let i = 0; i < plans.length; i++) {
        if (!plans[i].feedBackId) {
          this.$Message.warning(`不合格项 ${i + 1} 缺少有效编号，请刷新详情后重试`)
          return
        }
      }
      const id = this.detailOrder && this.detailOrder.id
      if (!id) return
      const form = this.$refs.wf2Form
      if (!form) return
      form.validate(async (valid) => {
        if (!valid) return
        this.wfLoading = true
        try {
          await this.$Ajax.post(`${API}/WorkflowEngineeringSubmit`, {
            id,
            feedBackTreatmentPlans: plans.map((p) => ({
              feedBackId: p.feedBackId,
              temporaryTreatmentPlan: String(p.temporaryTreatmentPlan || '').trim(),
              engineeringPlanFiles: (p.pics || []).map((x) => ({
                fileGuids: x.fileGuids || x.guid,
                fileName: x.fileName || undefined,
                url: x.url || undefined,
              })),
            })),
            engineeringDisposalConclusionType: this.wf2.engineeringDisposalConclusionType,
            engineeringPersonUserId: this.wf2.engineeringPersonUserId,
          })
          this.$Message.success('已提交')
          await this.loadDetail()
          this.loadList()
        } catch (e) {
          /* */
        } finally {
          this.wfLoading = false
        }
      })
    },
    async submitWf3() {
      const id = this.detailOrder && this.detailOrder.id
      if (!id) return
      if (this.detailShowLiabilityWorkflow) {
        const form = this.$refs.wfLiabilityForm
        if (!form) return
        form.validate(async (valid) => {
          if (!valid) return
          this.wfLoading = true
          try {
            await this.$Ajax.post(`${API}/WorkflowQualityFinalize`, {
              id,
              liabilityUnitOrDept: String(this.wfLiability.liabilityUnitOrDept || '').trim(),
              liabilityPerson: String(this.wfLiability.liabilityPerson || '').trim(),
              liabilityDefectCategoryType: this.wfLiability.liabilityDefectCategoryType,
              liabilitySupplementDescription:
                String(this.wfLiability.liabilitySupplementDescription || '').trim() || undefined,
            })
            this.$Message.success('已结案')
            await this.loadDetail()
            this.loadList()
          } catch (e) {
            /* */
          } finally {
            this.wfLoading = false
          }
        })
        return
      }
      this.wfLoading = true
      try {
        await this.$Ajax.post(`${API}/WorkflowQualityFinalize`, { id })
        this.$Message.success('已结案')
        await this.loadDetail()
        this.loadList()
      } catch (e) {
        /* */
      } finally {
        this.wfLoading = false
      }
    },
  },
}
</script>

<style scoped>
.rma-order-page {
  position: relative;
  min-height: 120px;
}
.rma-order-page .page-body {
  padding: 0 0 8px 0;
}
.rma-detail-modal-body {
  position: relative;
  max-height: 72vh;
  overflow-y: auto;
  padding-right: 2px;
}
.rma-empty {
  padding: 24px 12px;
  text-align: center;
  color: #5c6570;
  font-size: 14px;
}
.rma-detail-hero {
  margin-bottom: 10px;
  padding: 8px 10px;
  background: linear-gradient(135deg, #f7f8fa 0%, #f0f4f8 100%);
  border-radius: 6px;
  border: 1px solid #e8eaec;
}
.rma-detail-hero-main {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
}
.rma-detail-hero-record {
  font-size: 16px;
  font-weight: 600;
  color: #101828;
  letter-spacing: 0.01em;
}
.rma-detail-hero-meta {
  margin-top: 4px;
  font-size: 13px;
  color: #3d4652;
}
.rma-detail-hero-line {
  margin-top: 4px;
  font-size: 13px;
  color: #5a6470;
  line-height: 1.45;
}
.rma-detail-hero-dot {
  margin: 0 6px;
  opacity: 0.55;
}
.rma-section {
  margin-bottom: 10px;
}
.rma-section-head {
  font-size: 14px;
  font-weight: 600;
  color: #101828;
  margin-bottom: 6px;
  padding-bottom: 4px;
  border-bottom: 1px solid #e8eaec;
}
.rma-section-head--inset {
  border-bottom: 1px solid #e8eaec;
  padding-bottom: 4px;
  margin-bottom: 6px;
}
.rma-section-head--sub {
  font-size: 13px;
  font-weight: 600;
  margin-bottom: 6px;
  padding-bottom: 2px;
  border-bottom: none;
  color: #364152;
}
.rma-hint {
  margin: 0 0 6px 0;
  font-size: 13px;
  color: #5a6470;
  line-height: 1.5;
}
.rma-detail-main-tabs >>> .ivu-tabs-bar {
  margin-bottom: 8px;
}
.rma-detail-tab-detail .rma-fb-section,
.rma-detail-tab-detail .rma-detail-kv-readonly,
.rma-detail-tab-detail .rma-ops {
  margin-top: 14px;
}
.rma-native-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
  border: 1px solid #e8eaec;
}
.rma-native-table th,
.rma-native-table td {
  border: 1px solid #e8eaec;
  padding: 8px 10px;
  vertical-align: top;
}
.rma-detail-kv-table {
  table-layout: fixed;
}
.rma-detail-kv-table col.rma-kv-col-label {
  width: 120px;
}
.rma-detail-kv-table col.rma-kv-col-value {
  width: auto;
}
.rma-detail-kv-table .rma-kv-label {
  width: 120px;
  max-width: 120px;
  min-width: 120px;
  box-sizing: border-box;
  background: #fafbfc;
  color: #5c6570;
  font-weight: 500;
  white-space: nowrap;
}
.rma-detail-liability-kv .rma-kv-value {
  min-width: 0;
}
.rma-detail-kv-table .rma-kv-value {
  word-break: break-word;
  white-space: normal;
  background-color: #ffffff;
}
.rma-detail-kv-table .rma-kv-pre {
  white-space: pre-wrap;
}
.rma-detail-tab-detail .rma-detail-kv-readonly .rma-detail-kv-table,
.rma-detail-tab-detail
  .rma-wf-process-inline.rma-wf-process-inline--readonly
  .rma-detail-kv-table.rma-wf-inline-kv {
  background-color: #ffffff;
}
.rma-detail-log-table thead th {
  background: #f8f8f9;
  font-weight: 600;
  color: #515a6e;
  text-align: left;
}
.rma-detail-log-table tbody tr {
  background: #ffffff;
}
.rma-table-empty {
  text-align: center;
  color: #808695;
  padding: 16px 10px;
}
.rma-fb-section-head {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 6px;
  margin-bottom: 10px;
  padding-bottom: 6px;
  border-bottom: 1px solid #e8eaec;
}
.rma-fb-section-title {
  font-size: 14px;
  font-weight: 600;
  color: #101828;
}
.rma-fb-section-count {
  font-size: 12px;
  color: #5a6470;
}
.rma-fb-section-hint {
  flex: 1 1 100%;
  font-size: 12px;
  color: #5c6570;
  line-height: 1.45;
}
.rma-fb-collapse-form {
  margin-top: 2px;
}
.rma-wf2-under-fb {
  margin-top: 12px;
  padding: 12px 12px 4px;
  background: #f8fafc;
  border-radius: 6px;
  border: 1px solid #e8eaec;
  border-left: 3px solid #19be6b;
}
.rma-wf2-under-fb-head {
  font-size: 13px;
  font-weight: 600;
  color: #374151;
  margin: 0 0 10px 0;
}
.rma-wf2-footer {
  margin-top: 14px;
  padding: 12px 12px 4px;
  background: #f8fafc;
  border-radius: 6px;
  border: 1px solid #e8eaec;
  border-left: 3px solid #19be6b;
}
.rma-wf2-under-fb--readonly {
  border-left-color: #808695;
  background: #f9fafb;
}
.rma-wf2-readonly-kv {
  margin-bottom: 0;
}
.rma-engineering-readonly-note {
  font-size: 12px;
  color: #5c6570;
  margin: 0 0 10px 0;
  line-height: 1.45;
}
.rma-fb-collapse {
  border: none;
  background: transparent;
}
.rma-fb-collapse >>> .ivu-collapse-item {
  border: 1px solid #e8eaec;
  border-left: 3px solid #2d8cf0;
  border-radius: 6px;
  margin-bottom: 10px;
  overflow: hidden;
  background: #fff;
  box-shadow: 0 1px 2px rgba(23, 35, 61, 0.06);
}
.rma-fb-collapse >>> .ivu-collapse-item:last-child {
  margin-bottom: 0;
}
.rma-fb-collapse >>> .ivu-collapse-header {
  height: auto;
  line-height: 1.5;
  padding: 10px 12px;
  background: linear-gradient(180deg, #f8fafc 0%, #f4f7f9 100%);
  font-size: 13px;
  font-weight: 600;
  color: #2f3540;
}
.rma-fb-collapse >>> .ivu-collapse-header i {
  margin-right: 6px;
}
.rma-fb-collapse >>> .ivu-collapse-content > .ivu-collapse-content-box {
  padding: 0;
}
.rma-fb-panel-hd {
  display: inline-flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  vertical-align: middle;
}
.rma-fb-panel-tag {
  font-weight: normal;
}
.rma-fbline-body {
  padding: 10px 12px 12px;
}
.rma-fb-desc-group {
  margin-bottom: 12px;
  border-radius: 4px;
  overflow: hidden;
}
.rma-fbline-label--desc {
  display: block;
  font-size: 12px;
  font-weight: 600;
  color: #5c6570;
  margin: 0;
  padding: 8px 12px;
  background: #e8eaed;
}
.rma-fbline-label {
  font-size: 12px;
  color: #5c6570;
  margin-bottom: 4px;
  font-weight: 500;
}
.rma-fbline-label + .rma-fbline-pics {
  margin-top: 0;
}
.rma-fbline-desc {
  font-size: 13px;
  color: #2f3540;
  line-height: 1.55;
  /* white-space: pre-wrap; */
  word-break: break-word;
}
.rma-fbline-desc--main {
  margin: 0;
  padding: 10px 12px;
  font-size: 13px;
  color: #2f3540;
  line-height: 1.55;
  background: #f5f6f8;
}
.rma-fbline-pics {
  padding: 8px;
  background: #fafbfc;
  border-radius: 4px;
  border: 1px dashed #e8eaec;
}
.rma-thumb--fb {
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.08);
}
.rma-uploads {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
}
.rma-uploads--mt {
  margin-top: 6px;
}
.rma-thumb {
  position: relative;
  width: 64px;
  height: 64px;
  border: 1px solid #e8eaec;
  border-radius: 4px;
  overflow: visible;
  background: #f7f7f7;
  flex-shrink: 0;
}
.rma-thumb--rounded {
  border-radius: 4px;
}
.rma-thumb img {
  max-width: 100%;
  max-height: 100%;
  width: 100%;
  height: 100%;
  object-fit: cover;
  cursor: pointer;
  border-radius: 4px;
  vertical-align: top;
}
.rma-upload-add {
  width: 64px;
  display: inline-block;
  vertical-align: top;
}
.rma-upload-add >>> .ivu-upload-drag {
  border-radius: 4px;
  border-style: dashed;
}
.rma-upload-add-inner {
  width: 64px;
  height: 64px;
  line-height: 64px;
  text-align: center;
  font-size: 22px;
  color: #8c9199;
}
.rma-wf-form >>> .ivu-form-item {
  margin-bottom: 10px;
}
.rma-wf-form >>> .ivu-form-item-error {
  margin-bottom: 20px;
}
.rma-wf-form >>> .ivu-form-item-label {
  font-size: 13px;
  color: #3d4652;
}
.margin-top-10 {
  margin-top: 10px;
}
.rma-ops {
  margin-top: 4px;
  padding: 8px 10px;
  background: #f8fafc;
  border-radius: 6px;
  border: 1px solid #e8eaec;
  border-left: 3px solid #2d8cf0;
}
.rma-wf2-fb-title {
  font-size: 13px;
  font-weight: 600;
  color: #374151;
  margin-bottom: 8px;
}
.rma-wf3 {
  border-left-color: #ff9900;
}
.rma-wf-liability {
  border-left-color: #ed4014;
}
.rma-wf-liability-form >>> .rma-wf-liability-fields-row .ivu-form-item {
  margin-bottom: 10px;
}
.rma-warn {
  color: #cf3c12;
  margin: 0 0 6px 0;
  font-size: 13px;
  line-height: 1.45;
}
.rma-detail-modal-footer {
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
}
.rma-thumb-del-hit {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 2;
  width: 100px;
  height: 100px;
  box-sizing: border-box;
  padding: 4px;
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
  cursor: pointer;
}
.rma-thumb-del-icon {
  width: 22px;
  height: 22px;
  flex-shrink: 0;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.52);
  color: #fff;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
  pointer-events: none;
  transition: background 0.15s ease, transform 0.12s ease;
}
.rma-thumb-del-hit:hover .rma-thumb-del-icon {
  background: rgba(237, 64, 20, 0.95);
  transform: scale(1.06);
}
.rma-thumb-del-hit:active .rma-thumb-del-icon {
  transform: scale(0.96);
}
.rma-wf-process-inline {
  border-left-color: #ff9900;
}
.rma-wf-inline-kv {
  margin-bottom: 0;
}
.rma-subflow-reg .rma-native-table:last-child {
  margin-bottom: 0;
}
.rma-detail-kv-readonly {
  border-left-color: #94a3ab !important;
  background: linear-gradient(180deg, #fbfcfd 0%, #f8fafc 100%);
}
.rma-wf-process-inline--readonly .rma-section-head--sub {
  margin-top: 8px;
}
.rma-wf-process-inline--readonly .margin-top-10:first-of-type {
  margin-top: 8px;
}
.rma-wf-process-actions {
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 8px;
  padding-top: 10px;
  margin-top: 4px;
  border-top: 1px solid #e8eaec;
}
.rma-wf-process-inline .rma-pic-uploader {
  line-height: 1;
  margin-bottom: 0;
  vertical-align: bottom;
  display: inline-block;
}
.rma-wf-process-inline .rma-pic-uploader >>> .ivu-upload {
  line-height: 1;
}
.rma-wf-process-inline .rma-pic-add {
  width: 64px;
  height: 64px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0;
  padding: 0;
  border: 1px dashed #dcdee2;
  border-radius: 4px;
  background: #fafafa;
  color: #515a6e;
  cursor: pointer;
  user-select: none;
  transition: border-color 0.2s ease, background 0.2s ease;
}
.rma-wf-process-inline .rma-pic-add:hover {
  border-color: #2d8cf0;
  background: #f5f9ff;
}
.rma-wf-process-inline .rma-pic-add:hover .rma-pic-add-ico {
  color: #2d8cf0;
}
.rma-wf-process-inline .rma-pic-add-ico {
  color: #8c9199;
  transition: color 0.15s ease;
}
.rma-wf-process-inline .rma-pic-add-t {
  margin-top: 2px;
  font-size: 11px;
  font-weight: 500;
  color: #808695;
}
.rma-wf-process-inline .rma-pic-add-hint {
  font-size: 10px;
  color: #8c8c8c;
  line-height: 1.1;
  text-align: center;
}
</style>
<style>
.rma-detail-ivu-modal .ivu-modal-body {
  padding: 10px 14px 8px;
}
.rma-detail-ivu-modal .ivu-modal-header {
  border-bottom: 1px solid #f0f0f0;
  padding: 10px 14px;
}
.rma-detail-ivu-modal .ivu-modal-header-inner {
  font-size: 16px;
  font-weight: 600;
  color: #101828;
}
.rma-detail-ivu-modal .ivu-modal-footer {
  border-top: 1px solid #e8eaec;
  padding: 8px 14px;
  background: #fafbfc;
}
</style>
